// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* --- THEMES --- */

:root[theme="light"] {
  --bg: #fff;
  --white: #fff;
  --font-dark: #15304f;
  --font-light: #858896;
  --border: #dddddd;
  --secondary: #e9e9e9;
  --secondary-dark: #d6d6d6;
  --lighter-2: #a2a9b6;
  --dark: #272B2C;
  --light: #ddd;
  --lighter: #eee;
  --accent-1: #101828;
  --accent-2: #2f2f2f;
  --hyperlink-blue: blue;
  --avetta-blue: #0c2a4a;
  --avetta-blue-dark: #042344;
  --info: #0288d1;
  --primary: #085d49;
  --passed: #09de71;
  --success: #09de71;
  --warn: #ffa937;
  --error: #de3730;
  --failed: #de3730;
  --textbase: #101828;
  --primarybg: #dcfaec;
}

:root[theme="dark"] {
  --bg: #333;
  --white: #222425;
  --font-dark: #b3b1ab;
  --font-light: #979086;
  --border: #373b3c;
  --secondary: #2d3032;
  --secondary-dark: #373b3c;
  --lighter-2: #2b2d2f;
  --dark: #eee;
  --light: #555;
  --lighter: #444;
  --accent-1: #efefef;
  --accent-2: #eee;
  --hyperlink-blue: cornflowerblue;
  --avetta-blue: #8b9fb4;
  --avetta-blue-dark: #7994b1;
  --info: #0288d1;
  --primary: #085d49;
  --passed: #09de71;
  --success: #09de71;
  --warn: #ffa937;
  --error: #de3730;
  --failed: #de3730;
  --textbase: #101828;
  --primarybg: #dcfaec;
}

#theme-toggle {
  width: 15px;
  height: 15px;
  border-radius: 5px;
  background: var(--dark);
  cursor: pointer;
  transition: 0.3s;
}

/* --- OVERRIDES --- */

html, body {
  height: 100%;
  margin: 0;
  color: var(--dark);
  font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Ubuntu,sans-serif;
  font-weight: normal;
  font-size: 0.95rem;
  background: var(--bg);
  overflow-x: hidden;
}

h1, h2, h3, h4, h5, h6 {
  margin: 0;
  font-weight: 600;
}

h1 {
  margin: 0;
}

::placeholder {
  color: var(--dark);
}

.form-section ::placeholder {
  color: #999;
}

/* --- LAYOUT --- */

main {
  display: flex;
  flex-direction: row;
  height: 100%;
}


/* --- SIDEBAR --- */

#sidebar-wrapper {
  width: 250px;
  min-width: 250px;
  position: relative;
}

#sidebar {
  position: fixed;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 250px;
  min-width: 250px;
  overflow: hidden;
  overflow-y: auto;
  top: 10px;
  height: 100%;
  border-right: 1px solid var(--lighter);
}

.sidebar-section {
  padding: 1.6rem;
  box-sizing: border-box;
}

.sidebar-section button {
  line-height: 1;
  height: auto;
}

#sidebar > div > div img {
  max-height: 60px;
  max-width: 100%;
}

#sidebar > div > div * {
  /*display: block;*/
  margin-bottom: 0.8rem;
}

#sidebar > div > ul {
  margin-top: 1.6rem;
}

#sidebar ul ul {
  margin-top: 0.8rem;
}

#sidebar li {
  list-style: none;
  margin-bottom: 0.8rem;
  transition: 0.1s;
}

#sidebar li:only-child {
  margin-bottom: 0;
}

#sidebar ul > li > ul > li > ul > li {
  margin-left: 0.8rem;
}

#sidebar ul > li > ul > li > ul > li > ul > li {
  margin-left: 0.8rem;
}

#sidebar ul > li > ul > li > ul > li > ul > li > ul > li {
  margin-left: 0.8rem;
}

#sidebar ul ul {
  margin-left: 0.8rem;
}

#sidebar li.accordion {
  position: relative;
}

#sidebar li.accordion::after {
  content: '\\e975';
  display: inline-block;
  position: absolute;
  right: 0;
  top: 0;
  opacity: 0.5;
  font-family: 'spudfont' !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 30px;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 1.2rem;
}

#sidebar li.accordion:hover::after {
  opacity: 1;
}

#sidebar li.accordion.open::after {
  transform: rotate(90deg);
}


#sidebar button,
#sidebar .button,
#sidebar a {
  border: none;
  outline: none;
  background: transparent;
  text-align: left;
  width: 100%;
  padding: 0;
  cursor: pointer;
  color: var(--dark);
  font-family: inherit;
  font-weight: normal;
  font-size: 0.975rem;
  opacity: 0.7;
  margin: 0;
}

#sidebar button:hover,
#sidebar .button:hover,
#sidebar a:hover {
  opacity: 1;
}

#sidebar button.selected,
#sidebar .button.selected,
#sidebar a.selected {
  font-weight: 600;
  opacity: 1;
}

.accordion > ul {
  display: none;
}

.accordion.open > ul {
  display: block;
}

#sidebar .accordion button {
  padding-right: 20px;
}

#sidebar .accordion a {
  padding-right: 20px;
}


/* --- CONTENT --- */

#content {
  flex: auto;
  display: flex;
  flex-direction: column;
  background: var(--bg);
}

.content-box {
  padding: 2.5rem 4.5rem;
  box-sizing: border-box;
}

.centered-layout .content-box {
  padding-left: 0;
  padding-right: 0;
}

.content-box:not(:last-child) {
  border-bottom: 1px solid var(--lighter);
}

.toolbar {
  display: flex;
  flex-direction: row;
  box-sizing: border-box;
  justify-content: space-between;
  padding: 0;
  margin-bottom: 0.8rem;
}

footer.toolbar {
  margin-bottom: 0;
}

.content-box .toolbar:only-child {
  margin: 0;
}

.content-box h3 {
  margin-bottom: 0.8rem;
}

/* -------------------------- */

#page-wrapper {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0;
  overflow: hidden;
}

.page-wrapper {
  display: flex;
  justify-content: center;
}

.page-centered {
  max-width: 960px;
  flex: 1;
}

#page {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
}

.relative {
  position: relative;
}

#login-form-container {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

header {
  /*align-content: flex-start;*/
}

#auth-left {
  flex: 35%;
  min-width: 300px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
  overflow-y: auto;
  height: 100vh;
  padding: 1.6rem;
  box-sizing: border-box;
  background: var(--bg);
}

#auth-left > *:first-child {
  width: 100%;
  max-width: 300px;
  margin-top: 20%;
  align-self: center;
}

.splash-container {
  display: flex;
  flex-direction: column;
  align-items: center;

  .form-label {
    font-weight: bold;
  }
}

.splash-container .form-logo-container {
  width: 50%;
  margin-bottom: 10px !important;
  text-align: center;
  justify-content: center;
}

#auth-left .form-logo-container {
  text-align: center;
  margin-bottom: 4rem;
}

#auth-left .form-logo-container img {
  max-height: 80px;
  max-width: 100%;
  margin: 0 auto;
}

.company-tagline {
  text-align: center;
  color: var(--avetta-blue);
}

#sign-in-text {
  margin: 20px 0px;
  font-weight: bold;
  font-size: 22px;
}

.fill-width {
  width: 100% !important;
}

.splash-container .lang-container{
  text-align: left;
}

.splash-container .fill-width .dropdown button{
  width: 100%;
  justify-content: space-between;
  align-items: center;
  background-color: var(--secondary);
  border: none;
  color: var(--font-dark);
  font-weight: 400;
  font-size: 13px;
}

.avetta-blue-heading {
  text-align: center;
  color: var(--avetta-blue-dark);
}

.primary-btn{
  background-color: #00a26a !important;
}

.splash-container .or-line {
  color: #c6d1df;
  ;
  width: 100%;
  text-align: center;
  border-bottom: 1.2px solid #c6d1df;
  line-height: 0.1em;
  margin: 30px 0;
}

.splash-container .or-line span {
  background: var(--bg);
  padding: 0 10px;
}

.splash-container .login-as-visitor {
  background-color: #005cff;
}

.splash-container .contact-our-team {
  margin: 35px 0 10px !important;
}

.contact-our-team {
  text-align: center !important;
  align-items: center !important;
  margin: 10px 0 10px !important;
  font-size: 0.9rem !important;
  font-weight: 400 !important;
  border: solid #edf0f6 !important;
  border-width: 1px !important;
  padding: 1.5rem 0 !important;
  color: #0c2a4a;
}

.contact-our-team svg {
  margin: -5px auto 0;
  display: block;
  width: 40%;
  padding: 0;
}

.full-btn {
  text-align: center !important;
  color: #fff !important;
  font-size: 0.9rem !important;
  font-weight: 400 !important;
  height: 40px !important;
  border-radius: 8px !important;
  border-width: 0 !important;
}

#activate-peg-account {
  text-align: center;
  min-width: 320px;
  width: unset !important;
  max-width: unset !important;
  margin-top: 20px !important;
}

#verify-sso-outer {
  flex: 35%;
  min-width: 300px;
  display: flex;
  flex-direction: column;
  row-gap: 30px;
  align-items: center;
  overflow: hidden;
  overflow-y: auto;
  height: 100vh;
  padding: 1.6rem;
  box-sizing: border-box;
  background: #ffffff;
}

.verify-sso-container {
  max-width: 320px !important;
  display: flex;
  flex-direction: column;
  row-gap: 35px;
  text-align: center;
}

#auth-left .form-header {
  margin-bottom: 0.8rem;
  font-weight: 500;
  font-size: 1.2rem;
}

#auth-left .form-section {
  margin-bottom: 0.8rem;
}

#auth-right {
  flex: 65%;
  background-size: cover !important;
  background-position: center !important;
  background: var(--lighter);
}

ul {
  margin: 0;
  padding: 0;
}

.richtext ul {
  margin: 1rem;
  padding: 0 1rem;
}

.text-colour {
  color: var(--text);
}

a,
a:visited,
a:active,
a:focus {
  text-decoration: none;
  color: inherit;
}

i {
  font-size: 1rem;
}

i.rotate-90::before {
  display: inline-block;
  transform: rotate(90deg);
}

i.rotate-180::before {
  display: inline-block;
  transform: rotate(180deg);
}


i.rotate-270::before {
  display: inline-block;
  transform: rotate(270deg);
}

hr {
  border: none;
  border-top: 1px solid var(--light);
}

iframe {
  border: none;
}

.top-0 {
  top: 0 !important;
}

.border-radius-default {
  border-radius: 0.1rem;
}

.logo-preview {
  max-width: 100%;
  height: 80px;
  display: block;
  /*margin: 0 auto;*/
}

#menu {
  width: 200px;
  border-right: 1px solid var(--dark);
}

.content-wrapper {
  flex: 1 auto;
  flex-direction: column;
  display: flex;
  align-items: stretch;
}

.content {
  flex: 1 auto;
  width: 100%;
}

.content-wrapper:not(:first-child) {
  border-left: 1px solid var(--light);
}

#console {
  height: 100px;
  margin-top: 0.8rem;
}

#console ul {
  height: 100%;
  overflow-y: auto;
  flex-direction: column-reverse;
  display: flex;
}

.panel-box {
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  position: relative;
  align-content: flex-start;
}

.panel-box-border-right {
  border-right: 1px solid var(--dark);
}

.panel-box-toolbar {
  height: 20px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  background: var(--light);
  line-height: 20px;
}

.panel-box-toolbar > * {
  height: 100%;
}

.panel-box-content {
  overflow: hidden;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.panel-box-content > * {
  flex: 1 auto;
}

.panel-box-content > *:not(:first-child) {
  border-left: 1px solid var(--light);
}

.page-content {
  position: relative;
}

.page-content .toolbar {
  border: none;
}

.page-content .toolbar .tab {
  padding: 0 0.8rem;
}

.page-content .toolbar.tab:hover {
  background: var(--accent-1);
  color: var(--lighter);
}

.page-content .toolbar .tab.active {
  background: var(--lighter);
  pointer-events: none;
}

.page-content .toolbar input {
  /*color: var(--dark);*/
  background: var(--lighter);
  border: 1px solid var(--accent-1);
  border-radius: 0.2rem;
  padding-left: 0.8rem;
}

.page-content .toolbar input:focus,
.page-content .toolbar input:not(:placeholder-shown) {
  /*background: var(--light);*/
  /*color: var(--lighter);*/
}

.page-content-inner {
  position: absolute;
  top: 30px;
  bottom: 0;
  left: 0;
  right: 0;
  /*padding: 0 0.4rem 0.4rem 0;*/
  display: flex;
}

.page-content-inner .toolbar {
  border-top: 1px solid var(--lighter);
}

.page-content-inner .padding {
  padding: 0.8rem;
}

.page-content-inner > *:first-child:last-child {
  flex: auto;
}

.page-content-inner > *:first-child:not(:last-child) {
  flex: 30%;
}

.page-content-inner > *:last-child:not(:first-child) {
  flex: 70%;
  background: var(--lighter);
  border-left: 1px solid var(--light);
}

/*.page-content-inner table:not(.sortable-table) th:first-child,
    .page-content-inner table:not(.sortable-table) td:first-child {
        padding-left: 0.8rem;
    }*/

.page-content-box {
  margin: 1rem;
  border: 1px solid var(--light);
  border-radius: 0.2rem;
  overflow: hidden;
  overflow-y: auto;
  flex: auto;
}

.content-box-header {
  padding: 0.2rem 0.8rem;
  border-bottom: 1px solid var(--light);
  background: var(--light);
  text-transform: uppercase;
  font-size: 0.85rem;
}

.content-box-content {
  padding: 0.8rem;
}

.content-container {
  height: 100%;
  overflow: auto;
}

.tab {
  padding: 0 0.4rem;
  white-space: nowrap;
}

.tab:not(.active) {
  cursor: pointer;
}

.tab.focus {
  background: var(--dark);
  color: var(--light);
}

.flex-column {
  display: flex;
  flex-direction: column;
}

.flex-row {
  display: flex;
  flex-direction: row;
}

.flex-auto {
  flex: auto;
}

.flex-float-left {
  margin-right: auto !important;
}

.flex-float-right {
  margin-left: auto !important;
}

.flex-fit-content {
  flex: initial;
}

.flex-horizontal-content {
  display: flex;
  justify-content: space-between;
}

.center-content {
  justify-content: center;
  align-items: center;
}

.justify-between {
  justify-content: space-between;
}

.align-center {
  align-items: center;
}

.align-middle {
  vertical-align: middle;
}

.align-left {
  text-align: left !important;
}

.full-height {
  height: 100%;
  max-height: none !important;
}

.full-width {
  width: 100%;
  max-width: none !important;
}

.min-height-default {
  min-height: 50vh;
}

.hidden {
  display: none;
}

.translucent {
  opacity: 0.5;
}

.break-word,
.break-word * {
  word-break: break-word;
}

.arrow-forward {
  font-size: 0.8rem;
  transform: rotate(180deg);
  display: inline-block;
  vertical-align: middle;
  margin: 0 0.4rem;
}

table {
  text-align: left;
  border-collapse: collapse;
}

tr {
  height: 2.4rem;
}

th {
  position: sticky;
  top: 0;
  z-index: 1;
  font-weight: 500;
  text-transform: uppercase;
  background: var(--bg);
  box-shadow: 0 2px 0 var(--border);
  font-size: 0.85rem;
}

table tbody tr {
  border-bottom: 1px solid var(--light);
}

table:not(.no-hover) tbody tr:hover {
  background: var(--lighter);
}

/* table:not(.no-hover) tbody tr:hover a,
        table:not(.no-hover) tbody tr:hover button {
            color: var(--text);
        }

        table:not(.no-hover) tbody tr:hover .label {
            background: none !important;
            color: var(--text);
        }*/

table.fixed-table {
  table-layout: fixed;
}

table.ellipsis th:not(:first-child):not(:last-child),
table.ellipsis td:not(:first-child):not(:last-child) {
  padding: 0.4rem;
}

table.ellipsis th:first-child,
table.ellipsis td:first-child {
  padding-top: 0.4rem;
  padding-right: 0.4rem;
  padding-bottom: 0.4rem;
}

table.ellipsis th:last-child,
table.ellipsis td:last-child {
  padding-top: 0.4rem;
  padding-left: 0.4rem;
  padding-bottom: 0.4rem;
}

table.ellipsis td,
table.ellipsis td a {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

table.activity-table tr:hover td {
  overflow: auto;
  white-space: normal;
  background: var(--light);
  cursor: default;
}

table.sortable-table th:last-child {
  width: 2.4rem;
}

table.sortable-table td:last-child {
  padding: 0 0.8rem;
}

table.sortable-table td:last-child i {
  cursor: ns-resize;
}

td a {
  display: block;
  color: inherit;
  padding-top: 0.2rem;
  padding-bottom: 0.2rem;
}

td button {
  display: inline-block;
}

td button:not(:first-child) {
  margin-left: 0.4rem;
}

.table-wrapper {
  overflow: hidden;
  overflow-y: auto;
}

.modal .table-wrapper {
  max-height: 50vh;
}

.modal .table-wrapper th {
  background: var(--bg);
}

.page-content .toolbar.table-footer,
.table-footer {
  margin-top: 1.6rem;
  height: 31px;
}

.td-truncated {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
  cursor: pointer;
}

.td-expanded {
  white-space: normal !important;
  overflow: visible !important;
  max-width: none !important;
}

.full-width {
  width: 100% !important;
  max-width: 100% !important;
}

.navbar {
  align-items: stretch;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.navbar-section {
  align-items: center;
  display: flex;
  /*flex: 1 0 0;*/
}

.navbar-section:not(:first-child):last-child {
  justify-content: flex-end;
}

.navbar-section:first-child > * {
  margin-right: 0.4rem;
}

.navbar-section:not(:first-child):last-child > * {
  margin-left: 0.4rem;
}

.navbar-section > * {
  height: 100%;
}

.titlebar-controls i {
  font-size: 16px;
  margin-left: 10px;
  cursor: pointer;
}

.label {
  padding: 0px 4px 1px 4px;
  border-radius: 0.1rem;
  vertical-align: top;
  display: inline-block;
  background: #f5f5f5;
  color: #050505;
}

.category-tag {
  display: inline-flex;
  align-items: center;
  padding: 0.15rem 0.5rem;
  border-radius: 1rem;
  font-size: 0.75rem;
  margin: 0.1rem;
  background: var(--secondary);
  color: var(--accent-1);
}

.category-tag.blended {
  background: #6C5CE7;  /* soft purple */
  color: #ffffff;
}

.category-tag.classroom {
  background: #0984E3;  /* clear blue */
  color: #ffffff;
}

.category-tag.online {
  background: #00B894;  /* teal green */
  color: #ffffff;
}

.category-tag.practical-assessment {
  background: #E17055;  /* warm orange/red */
  color: #ffffff;
}

.category-tag.unassigned {
  background: #B2BEC3;  /* neutral grey */
  color: #2d3436;
}

.category-tag.category-custom {
  display: inline-block;
  max-width: 150px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  vertical-align: middle;
}

.label-circle {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.label-circle-message {
  display: flex;
  align-items: flex-start; /* aligns dot to first line */
  gap: 0.5rem; /* spacing between dot and text */
}

.label-circle::before {
  content: "";
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: var(--light);
  flex-shrink: 0;
}

.label-circle-message::before {
  content: "";
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: var(--light);
  flex-shrink: 0;
  margin-top: 6px; /* adjust slightly for perfect alignment */
}

.bg-success,
.label.label-success,
.label-circle.label-success::before {
  background: var(--passed) !important;
}

.bg-success,
.label.label-success,
.label-circle-message.label-success::before {
  background: var(--passed) !important;
}

.bg-warning,
.label.label-warning,
.label-circle.label-warning::before {
  background: var(--warn) !important;
}

.bg-warning,
.label.label-warning,
.label-circle-message.label-warning::before {
  background: var(--warn) !important;
}

.bg-error,
.label.label-error,
.label-circle.label-error::before {
  background: var(--failed) !important;
}

.bg-error,
.label.label-error,
.label-circle-message.label-error::before {
  background: var(--failed) !important;
}

.bg-info,
.label.label-info,
.label-circle.label-info::before {
  background: var(--info) !important;
}

.bg-info,
.label.label-info,
.label-circle-message.label-info::before {
  background: var(--info) !important;
}

.text-larger,
.text-larger i {
  font-size: 1.2rem;
}
.text-sm,
.text-sm i {
  font-size: 1.0rem;
}
.text-xs,
.text-xs i {
  font-size: 0.875rem;
}

.col-10 {
  flex: 10%;
}

.col-12 {
  flex: 12%;
}

.col-15 {
  flex: 15%;
}

.col-20 {
  flex: 20%;
}

.col-25 {
  flex: 25%;
}

.col-30 {
  flex: 30%;
}

.col-33 {
  flex: 33.3333%;
}

.col-35 {
  flex: 35%;
}

.col-40 {
  flex: 40%;
}

.col-50 {
  flex: 50%;
}

.col-60 {
  flex: 60%;
}

.col-66 {
  flex: 66.6666%;
}

.col-70 {
  flex: 70%;
}

.col-80 {
  flex: 80%;
}

.col-85 {
  flex: 85%;
}

.col-88 {
  flex: 88%;
}

.col-90 {
  flex: 90%;
}

.col-100 {
  flex: 100%;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.4rem !important;
}

.mt-2 {
  margin-top: 0.8rem !important;
}

.mt-5 {
  margin-top: 3rem !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.4rem !important;
}

.mb-2 {
  margin-bottom: 0.8rem !important;
}

.mb-3 {
  margin-bottom: 1.2rem !important;
}

.mr-0 {
  margin-right: 0 !important;
}

.mr-1 {
  margin-right: 0.4rem !important;
}

.mr-2 {
  margin-right: 0.8rem !important;
}

.ml-0 {
  margin-left: 0 !important;
}

.ml-1 {
  margin-left: 0.4rem !important;
}

.ml-2 {
  margin-left: 0.8rem !important;
}

.m-0 {
  margin: 0 !important;
}

.m-1 {
  margin: 0.4rem !important;
}

.m-2 {
  margin: 0.8rem !important;
}

.p-0 {
  padding: 0 !important;
}

.p-1 {
  padding: 0.4rem;
}

.p-2 {
  padding: 0.8rem;
}

.pt-0 {
  padding-top: 0 !important;
}

.pt-1 {
  padding-top: 0.4rem !important;
}

.pt-2 {
  padding-top: 0.8rem !important;
}

.pt-5 {
  padding-top: 3rem !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pb-1 {
  padding-bottom: 0.4rem !important;
}

.pb-2 {
  padding-bottom: 0.8rem !important;
}

.pr-0 {
  padding-right: 0 !important;
}

.pr-1 {
  padding-right: 0.4rem !important;
}

.pr-2 {
  padding-right: 0.8rem !important;
}

.pl-0 {
  padding-left: 0 !important;
}

.pl-1 {
  padding-left: 0.4rem !important;
}

.pl-2 {
  padding-left: 0.8rem !important;
}

.padding {
  padding: 0.4rem;
  box-sizing: border-box;
}

.page-content-inner > .padding:not(:first-child) {
  border-top: 1px solid var(--light);
  margin-top: 0.4rem;
  padding-top: 0.8rem;
}

.text-gray {
  color: var(--light);
}

.text-gray i::after {
  border-left-color: var(--light) !important;
  border-bottom-color: var(--light) !important;
}

.text-primary {
  color: var(--accent-1);
}

.text-secondary {
  color: var(--accent-2);
}

.text-error {
  color: var(--failed);
}

.text-warning {
  color: var(--warn);
}

.text-info {
  color: var(--info);
}

.text-success {
  color: var(--passed);
}

.text-center {
  text-align: center;
}

.ellipsis {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.full-text {
  white-space: normal;
  overflow: visible;
}

.text-label {
  color: var(--accent-2);
  text-transform: uppercase;
  font-weight: 500;
  font-size: 0.85rem;
}

.text-bold {
  font-weight: 700;
}

.text-bolder {
  font-weight: 600;
}

.text-italic {
  font-style: italic;
}

.text-italic-course-description {
  font-style: italic;
  display: inline-flex;
  padding-left: 5px;
}

.text-uppercase {
  text-transform: uppercase;
}

.c-hand {
  cursor: pointer;
}

.clickable:hover {
  background-color: var(--lighter);
  cursor: pointer;
  text-decoration: none;
  border: none;
}

.center-this {
  width: 100%;
  padding: 3rem 0;
}

.disabled {
  pointer-events: none;
  opacity: 0.5;
}

input,
select,
textarea,
.input {
  border: 1px solid transparent;
  background: var(--lighter);
  color: var(--dark);
  padding: 0.4rem 0.6rem;
  border-radius: 0.1rem;
  box-sizing: border-box;
  max-width: 100%;
  min-height: 30px;
}

.input[contenteditable] {
  background: none;
  border: 1px solid var(--dark);
  border-top: none;
  outline: none;
  max-height: 400px;
  min-height: 150px;
  overflow: auto;
}

.text-editor.compact .input[contenteditable] {
  min-height: 38px;
  max-height: 100px;
}

select[multiple] {
  min-height: 200px;
}

label input {
  min-height: unset;
  padding: unset;
  border: unset;
  background: unset;
}

textarea {
  resize: vertical;
  font-family: inherit;
}

.has-error input,
input.has-error {
  border: 1px solid var(--failed);
}

input[type="search"] {
  background: none;
  border: 1px solid var(--accent-2);
  border-radius: 0.2rem;
}

.form input[type="search"] {
  border: 1px solid transparent;
  background: var(--lighter);
  border-radius: 0.1rem;
}

[type="search"]::-webkit-search-cancel-button,
[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none;
}

.autocomplete {
  position: relative;
}

.autocomplete ul {
  position: absolute;
  width: 100%;
  max-height: 150px;
  background: var(--bg);
  box-sizing: border-box;
  overflow: auto;
  z-index: 9;
}

.autocomplete ul:not(:empty) {
  border: 1px solid var(--accent-1);
  display: none;
}

.autocomplete input:focus ~ ul,
.autocomplete ul:hover {
  display: block;
}

.autocomplete li {
  cursor: pointer;
  padding: 0.2rem 0.4rem;
}

.autocomplete li:hover {
  background: var(--light);
}

.form {
  max-width: 400px;
}

.form.bordered-sections > .form-section:not(:last-child) {
  border-bottom: 1px solid var(--lighter);
  padding-bottom: 1rem;
}

.centered-page-form {
  margin: 3% auto;
  width: 300px;
}

.form-buttons {
  margin-top: 0.8rem;
  display: flex;
  /*justify-content: flex-end;*/
}

.form-buttons.flex-right {
  justify-content: flex-end;
}

.form-buttons button:not(:first-child) {
  margin-left: 0.4rem;
}

.form-buttons a:hover {
  text-decoration: underline;
}

.form-buttons a:visited,
.form-buttons a:active,
.form-buttons a:focus {
  color: var(--accent-1);
}

.form-section {
  margin-bottom: 1rem;
}

.form-section.form-section-narrow {
  max-width: 300px;
}

.details-list .form-section {
  margin-bottom: 1.4rem;
}

.form-section input:not([type=checkbox]):not([type=radio]),
.form-section select,
.form-section textarea {
  width: 100%;
  max-width: 100%;
}

.form-section input:focus,
.form-section select:focus,
.form-section textarea:focus {
  border: 1px solid var(--accent-2);
}

.form-section.with-button {
  display: flex;
}

.form-section.with-button > *:first-child {
  flex: 1;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.form-section.with-button > button {
  min-width: 30px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.form-section.has-error .form-label {
  color: var(--failed) !important;
}

.form-section-shared {
  display: flex;
  justify-content: space-between;
}

.form-section-shared > .form-section {
  flex: auto;
  max-width: 50%;
}

.form-section-shared > .form-section:first-child {
  padding-right: 0.8rem;
  box-sizing: border-box;
}

.form-section.agenda-input {
  display: flex;
  flex-wrap: wrap;
}

.form-section.agenda-input .form-label {
  width: 100%;
}

.form-section.agenda-input input:nth-child(2n) {
  flex: 29%;
  margin-right: 1%;
}

.form-section.agenda-input input:nth-child(3n) {
  flex: 59%;
  margin-right: 1%;
}

.form-section.agenda-input button {
  flex: 9%;
}

.form-input label {
  display: block;
}

.centered-page-form .form-section {
  margin-bottom: 0.8rem;
}

.checkbox-section i {
  font-size: 1.4rem;
  vertical-align: bottom;
}

.checkbox-section > div:first-child:not(.loading) {
  cursor: pointer;
}

.checkbox-section > div:not(:first-child):last-child {
  margin-left: 1.8rem;
}

.form-label {
  margin-bottom: 0.2rem;
  font-size: 0.9rem;
}

.form-label:empty {
  height: 1.2rem;
}

.required .form-label::after {
  content: "*";
  color: var(--failed);
  padding-left: 0.1rem;
}

.form img {
  max-width: 100%;
}

.signature-editor {
  width: 100%;
  background: var(--lighter);
  border-radius: 2rem;

  .signature-elements {
    padding: 20px;

    .clear-button {
      float: right;
    }

    /* .signature-canvas {
      width: 100%;
    } */

    .signature-hint {
      color: #999;
      text-align: center;
    };

    .signature-line {
      width: 90%;
    }
  }
}


/* FORM UNIT & FORM PREVIEW */

.form-unit {
  width: 100%;
  max-width: 450px;
  align-self: flex-start;
  max-height: 80%;
  margin: 0 auto;
  margin-top: 5%;
  background: var(--bg);
  border: 1px solid var(--dark);
  z-index: 1;
  position: relative;
  overflow-y: auto;
  box-sizing: border-box;
  padding: 2.4rem;
}

.form-preview .titlebar {
  display: flex;
  justify-content: space-between;
  padding-bottom: 1.4rem;
  border-bottom: 1px solid var(--lighter);
  box-sizing: border-box;
  text-transform: uppercase;
  font-weight: 500;
  font-size: 0.85rem;
  align-items: center;
}
.form-preview .titlebar-section {
  display: flex;
}

.form-unit.form-preview .form-section {
  padding: 0.2rem 0;
}

.form-unit.form-preview .form-section:hover {
  outline: 2px dotted var(--accent-1);
  outline-offset: 2px;
  cursor: pointer;
  position: relative;
}

.form-unit.form-preview .form-section *:hover {
  cursor: pointer;
}

.radio-button {
  position: relative;
  display: inline-block;
}

.radio-button:before {
  content: "";
  border: 1px solid var(--dark);
  border-radius: 50%;
  display: inline-block;
  width: 12px;
  height: 12px;
  margin-left: 0.3rem;
  margin-top: 0.15rem;
  position: relative;
}

.radio-button.checked:after {
  content: "";
  background-color: var(--dark);
  border-radius: 15px;
  display: block;
  top: 5px;
  left: 3px;
  width: 8px;
  height: 8px;
  position: absolute
}

.field-options .radio-button:before {
  border: 1px solid var(--dark);
  width: 10px;
  height: 10px;
  margin-left: 1px;
}

.field-options .radio-button.checked:after {
  background-color: var(--dark);
  top: 5px;
  left: 4px;
  width: 6px;
  height: 6px;
}

.form-preview .radio-button {
  vertical-align: middle;
}

.number-icon:before {
  content: "123";
  font-size: 0.6rem;
  vertical-align: middle;
}

/* CERTIFICATE UNIT EDITOR & TEXT EDITOR */

.text-editor-toolbar {
  display: flex;
  border: 1px solid var(--accent-1);
  padding: 0 0.4rem;
  border-radius: 0.2rem;
  line-height: 28px;
  height: 30px;
  white-space: nowrap;
}

.text-editor-toolbar i {
  cursor: pointer;
  font-size: 20px;
  height: 100%;
  padding: 0 0.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.text-editor-toolbar i:before {
  padding-bottom: 1px;
}

.text-editor-toolbar > *:hover {
  background: var(--accent-1);
  color: var(--lighter);
  border-radius: 0.2rem;
}

.tab-dropdown {
  position: relative;
}

.tab-dropdown ul {
  position: absolute;
  top: 22px;
  left: 0;
  min-width: 100%;
  display: none;
  background-color: var(--lighter);
  margin: 0;
  z-index: 99;
  border: 1px solid var(--accent-2);
  border-radius: 0 0 0.2rem 0.2rem;
  overflow: hidden;
  box-sizing: border-box;
}

.tab-dropdown-right ul {
  right: 0;
  left: unset;
}

.tab-dropdown:hover ul {
  display: block;
  z-index: 50;
}

.tab-dropdown ul li {
  list-style: none;
  margin: 0;
  padding: 5px 10px;
  color: var(--dark);
  line-height: 1.25;
  white-space: nowrap;
  cursor: pointer;
}

.tab-dropdown ul li:hover {
  background-color: var(--light);
  outline: 1px solid var(--dark)
}

/* CERTIFICATE PREVIEW */

.cert-variables code {
  word-break: break-all;
}

.certificate-preview {
  position: relative;
  flex: none;
  align-self: flex-start;
  width: 600px;
  max-width: 100%;
  /*margin: 0 auto;*/
  border: 1px solid var(--light);
  background: #fff;
  overflow: hidden;
  font-size: 24pt;
  color: #000;
}

.certificate-preview.landscape {
  width: 1000px;
}

.certificate-preview.portrait:before,
.certificate-preview:before {
  content: "";
  display: block;
  padding-top: 141%;
}

.certificate-preview.landscape:before {
  content: "";
  display: block;
  padding-top: 70%;
}

.certificate-preview img {
  position: absolute;
  height: 100%;
  top: 0;
  left: 0;
}

.certificate-preview .text-editor-input span {
  font-size: inherit;
  line-height: 1.5;
}

.cert-editor {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.cert-scaler {
  position: absolute;
  transform-origin: top left;
  width: 210mm;
  height: 297mm;
}

.landscape .cert-scaler {
  width: 297mm;
  height: 210mm;
}

.cert-body {
  height: 80%;
  top: 10%;
}

.cert-header,
.cert-body {
  border-bottom: 1px dashed #fbfbfb;
  box-sizing: border-box;
}

.cert-header,
.cert-footer {
  height: 10%;
}

.cert-header,
.cert-body,
.cert-footer {
  box-sizing: border-box;
  padding-left: 10px;
  padding-right: 10px;
}

.cert-header {
  padding-top: 10px;
}

.cert-footer {
  top: 90%;
  padding-bottom: 10px;
}

.cert-editor li {
  list-style: unset;
}

/* SMALL CERTIFICATE PREVIEWS */

.centered-layout .certs {
  display: flex;
  flex-wrap: wrap;
  gap: 15px 15px;
  justify-content: space-around;
}

.cert-icon {
  cursor: pointer;
  vertical-align: top;
}

.cert-icon-info {
  text-align: center;
}

.cert-icon-image {
  position: relative;
  margin: 0 auto;
  width: 212px;
  height: 100px;
  border-radius: 0.1rem;
  overflow: hidden;
  background-color: var(--light);
  background-size: cover;
  background-repeat: no-repeat;
  margin-bottom: 5px;
  pointer-events: none;
  border: 1px solid var(--light);
}

.cert-icon-image.portrait,
.cert-icon-image.landscape {
  height: unset;
}


.cert-icon-image.portrait {
  width: 150px;
}

.cert-icon-image.portrait:before {
  content: "";
  display: block;
  padding-top: 141%;
}

.cert-icon-image.landscape:before {
  content: "";
  display: block;
  padding-top: 70%;
}

.cert-icon-image iframe {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
}

/* ----- */

/* Tooltip */
.tooltip {
  position: relative;
}

.tooltip:hover::after {
  opacity: 1;
  transform: translate(-50%, -.2rem);
}

.tooltip:after {
  font-family: sans-serif;
}

.tooltip::after {
  background: var(--dark);
  border-radius: .1rem;
  bottom: -100%;
  color: var(--lighter);
  content: attr(data-tooltip);
  display: block;
  font-size: .7rem;
  left: 50%;
  max-width: 320px;
  opacity: 0;
  overflow: hidden;
  padding: .2rem .4rem;
  pointer-events: none;
  position: absolute;
  text-overflow: ellipsis;
  transform: translate(-50%, .4rem);
  transition: opacity .2s, transform .2s;
  white-space: pre;
  z-index: 300;
}

.inline-tip {
  position: relative;
  display: flex;
  align-items: center;
  gap: 1.5rem;
  white-space: nowrap;
}

.inline-tip::after {
  content: attr(data-tip);
  color: var(--dark);
  font-size: 0.75rem;
  white-space: nowrap;
}

/* ------- */

.has-icon-left, .has-icon-right {
  position: relative;
}

.has-icon-right > *:first-child {
  padding-right: 1.3rem;
  height: 100%;
  vertical-align: top;
}

.has-icon-right i {
  right: .05rem;
  color: var(--dark);
}

.has-icon-right input:focus ~ i,
.has-icon-right input:not(:placeholder-shown) ~ i {
  /*color: var(--lighter);*/
}

.has-icon-left i, .has-icon-right i {
  margin-left: 0.25rem;
  margin-right: 0.4rem;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
}

.has-icon-right i:first-of-type:not(:last-of-type) {
  display: none;
  margin-right: 1.8rem;
}

.has-icon-right input:not(:placeholder-shown) ~ i:first-of-type:not(:last-of-type) {
  display: block;
}

.btn,
button {
  font-family: inherit;
  border: 1px solid var(--accent-1);
  padding: 0 0.4rem;
  background: transparent;
  cursor: pointer;
  color: var(--accent-1);
  transition: 0.1s;
  border-radius: 0.2rem;
  font-weight: 500;
  line-height: 28px;
  height: 30px;
  white-space: nowrap;
}

.btn-padded {
  padding: 0.8rem 1.6rem;
  line-height: normal;
  height: auto;
}

.btn.with-icon,
button.with-icon {
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding-right: 0.6rem;
}

.dropbtn {
  background-color: #04AA6D;
  color: white;
  padding: 16px;
  font-size: 16px;
  border: none;
  cursor: pointer;
}

.dropbtn:hover, .dropbtn:focus {
  background-color: #3e8e41;
}

#orgs-dropdown-input:focus {outline: 3px solid #ddd;}

.orgs-dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #f6f6f6;
  min-width: 230px;
  overflow: auto;
  border: 1px solid #ddd;
  z-index: 1;
}

.dropdown-content a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

div#orgs-dropdown-items {
  max-height: 60vh;
}

.dropdown a:hover {background-color: #ddd;}

.show {display: block;}

.inc-acct-users {
  margin-bottom: 0px;
}

.with-icon.icon-right {
  padding-right: 0.4rem;
  padding-left: 0.6rem;
}

.with-icon i {
  padding-right: 0.2rem;
}

.with-icon.icon-right i {
  padding-right: 0;
  padding-left: 0.2rem;
}

.no-click {
  pointer-events: none;
}

.disable-buttons button,
.disable-buttons .btn,
buttons.disabled {
  opacity: 0.5;
  pointer-events: none;
}

.disable-fields input,
.disable-fields textarea,
.disable-fields select,
.disable-fields label,
.disable-fields button,
.disable-fields .signature-editor,
input.disable-fields,
textarea.disable-fields,
select.disable-fields,
label.disable-fields,
.signature-editor.disable-fields {
  pointer-events: none;
}

.btn-secondary {
  background-color: var(--light);
  border-color: var(--light);
}

.btn-text {
  border: none;
  background: none;
}

.btn-inverted {
  border: 2px solid var(--lighter);
  background: var(--lighter);
  color: var(--accent-1);
}

.btn-cta {
  background: var(--accent-1);
  color: var(--lighter);
}


.btn-cta:hover {
  background: var(--accent-2);
}

.btn-focus {
  background: var(--accent-1);
  color: var(--lighter);
}

.btn-focus:hover {
  outline: 2px solid var(--accent-1);
}

.btn-open::after {
  font-family: 'spudfont' !important;
  content: "\\e96a";
  font-size: 0.85rem;
  margin-left: 0.4rem;
}

.datepicker-container {
  position: relative;
  display: inline-block;
}

.datepicker-input {
  padding-right: 30px; /* Make space for the icon */
}

.calendar-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  color: #333; /* Adjust color as needed */
}

.btn-error {
  color: var(--failed);
  border: 1px solid var(--failed);
}

.text-danger {
    color: var(--failed);
}

.btn-warning {
  color: var(--warn);
  border: 1px solid var(--warn);
}

.btn-info {
  color: var(--info);
  border: 1px solid var(--info);
}

.btn-yes,
.btn-yes:hover {
  background: var(--passed);
  border: 1px solid var(--passed);
  color: var(--lighter);
}

.btn-no,
.btn-no:hover {
  background: var(--failed);
  border: 1px solid var(--failed);
  color: var(--lighter);
}

.text-italic{
  font-style: italic;
}

.username-approver{
  display: inline;
  font-weight: normal;
}

.btn-warning:hover {
  color: var(--lighter);
  background: var(--warn);
}

.btn-cta.btn-warning,
.btn-cta.btn-warning:hover {
  background: var(--warn);
  border: 1px solid var(--warn);
  color: var(--lighter);
}

.btn-info:hover {
  color: var(--lighter);
  background: var(--info);
}

.btn-cta.btn-info,
.btn-cta.btn-info:hover {
  background: var(--info);
  border: 1px solid var(--info);
  color: var(--lighter);
}

.btn-error:hover {
  color: var(--lighter);
  background: var(--failed);
}

.btn-cta.btn-error,
.btn-cta.btn-error:hover {
  background: var(--failed);
  border: 1px solid var(--failed);
  color: var(--lighter);
}

/* --- ALERTS --- */

.alert {
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  border-radius: 4px;
  border: 1px solid;
  font-size: 0.9rem;
  line-height: 1.5;
}
.alert-flex {
  display: flex;
  align-items: flex-start;
}

.alert-success {
  color: #035e30;
  background: #e6fcf1;
  border-color: var(--passed);
}

.alert-error {
  color: #8b1c1c;
  background: #fcebea;
  border-color: var(--error);
}

.alert-warning {
  color: #7a4500;
  background: #fff6eb;
  border-color: var(--warn);
}

.alert-info {
  color: #01527e;
  background: #e6f3fa;
  border-color: var(--info);
}

.btn-padding button,
.btn-padding .btn,
button.btn-padding,
.btn.btn-padding {
  padding: 0 0.8rem;
}

.btn-pulse {
  animation: pulse-animation 2s infinite;
}

@keyframes pulse-animation {
  0% {
    box-shadow: 0 0 0 0 rgba(207, 76, 77, 0.7);
  }

  100% {
    box-shadow: 0 0 0 7px rgba(207, 76, 77, 0);
  }
}

.btn-big {
  width: 30%;
  height: 75px;
  display: inline-flex !important;
  margin: 0.4rem;
  justify-content: center !important;
  font-weight: 600;
}

.btn-small {
  font-size: 0.8rem;
  height: 20px;
  line-height: 20px;
}

.toggle-section {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.btn.btn-toggle {
  height: 1.2rem;
  width: 2.4rem;
  min-width: 2.4rem;
  padding: 0;
  display: inline-flex;
  vertical-align: text-top;
  align-items: center;
  line-height: 1;
  background: var(--accent-1);
  opacity: 0.3;
  transition: 0.1s;
}

.btn.btn-toggle.active {
  opacity: 1;
  flex-direction: row-reverse;
}

.btn.btn-toggle::after {
  display: block;
  width: 0.9rem;
  min-width: 0.9rem;
  height: 0.9rem;
  background: var(--lighter);
  margin: 0.2rem;
  border-radius: 0.1rem;
  content: '';
  font-family: 'spudfont' !important;
  speak: none;
  font-style: normal;
  font-variant: normal;
  text-transform: none;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 0.9rem;
  color: var(--dark);
  font-weight: 600;
}

.btn.btn-toggle.active::after {
  content: '\\e92f';
}

.btn.btn-toggle[disabled],
.btn.btn-toggle.disabled {
  opacity: 0.15;              /* override active opacity */
  cursor: not-allowed;
  pointer-events: none;
  filter: grayscale(100%);
}

a:focus,
button:focus,
input:focus,
select:focus,
textarea:focus,
contenteditable:focus {
  outline: none;
}

.brackets {
  background-image: linear-gradient(var(--accent-1), var(--accent-1)), linear-gradient(var(--accent-1), var(--accent-1)), linear-gradient(var(--accent-1), var(--accent-1)), linear-gradient(var(--accent-1), var(--accent-1));
  background-repeat: no-repeat;
  background-size: 4px 1px;
  background-position: top left, top right, bottom left, bottom right;
  border: solid var(--accent-1);
  border-width: 0 1px;
  padding: 0 0.4rem;
}

.page-content-box + .toolbar {
  padding-top: 0;
}

header.toolbar {
  padding: 0 0.4rem;
  height: 40px;
  line-height: 38px;
  margin: 0;
  /*background: var(--lighter);*/
}

footer .toolbar {
  height: 30px;
  line-height: 28px;
  background: var(--dark);
  color: var(--light);
  border: none;
}

.main-toolbar {
  background: var(--accent-1);
  color: var(--light);
}

.secondary-toolbar {
  background: var(--light);
}

.toolbar-section {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.toolbar-section input,
.toolbar-section button {
  height: 30px;
}

.toolbar-section > *:not(:last-child) {
  margin-right: 0.4rem;
}

.toolbar-section.with-menu {
  align-items: start;
  flex-direction: column;
}

.toolbar-section.with-menu .toolbar-section {
  flex-direction: column;
  align-items: normal;
}

.toolbar-section.with-menu .toolbar-menu {
  margin-top: 1.2rem;
}

.toolbar-section.with-menu .toolbar-menu > * {
  margin-right: 1.2rem;
  font-weight: 500;
  display: inline-block;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  padding-bottom: 0.4rem;
  font-size: 1rem;
}

.toolbar-section.with-menu .toolbar-menu > *.active {
  border-bottom: 2px solid var(--dark);
}

.toolbar-section.with-menu .toolbar-menu > *:not(.active):hover {
  border-bottom: 2px solid var(--dark);
}

.toolbar-title {
  padding: 0 0.4rem;
  white-space: nowrap;
  height: 100%;
}

.toolbar-tabs {
  display: flex;
  flex-direction: row;
}

.toolbar-tabs > * {
  padding: 0 0.4rem;
  border: none;
  border-bottom: 1px solid transparent;
  color: inherit;
  white-space: nowrap;
}

.toolbar-tabs > *.active {
  border-bottom: 2px solid var(--accent-1);
}

.toolbar-tabs > button:not(.active):hover,
.toolbar-tabs > a:not(.active):hover {
  border-bottom: 1px solid var(--accent-2);
  cursor: pointer;
}

.toolbar-checkbox {
  width: 18px;
  padding: 0 0.4rem;
  align-self: center;
  cursor: pointer;
}

.toolbar-checkbox i,
.list-checkbox i {
  font-size: 1.2rem;
  opacity: 0.3;
  vertical-align: bottom;
}

.toolbar-checkbox i.icon-checkbox-checked,
.list-checkbox i.icon-checkbox-checked {
  opacity: 1;
}

.dropdown {
  position: relative;
  cursor: pointer;
  width: fit-content;
}

.dropdown button {
  max-width: 100%;
}

.dropdown:not(.auto-width) button {
  min-width: 150px;
}

.dropdown-list {
  display: none;
}

.dropdown-no-hover .dropdown-list{
  display: none !important;
}

.show-lang-dropdown .dropdown-list {
  display: block !important;
  position: absolute;
  box-sizing: border-box;
  margin-top: -1px;
  left: 0;
  z-index: 9;
  background: var(--lighter);
  border: 1px solid var(--accent-1);
  width: 100%;
}

.show-lang-dropdown.dropup .dropdown-list {
  bottom: 100%;
  margin-bottom: -1px;
  top: unset;
}

.show-lang-dropdown .dropdown-list > div {
  padding: 0.2rem 0.8rem;
}

.show-lang-dropdown.centered-content .dropdown-list > div {
  padding: 0.2rem 0;
  text-align: center;
}

.show-lang-dropdown .dropdown-list > .active {
  font-weight: 600;
}

.show-lang-dropdown .dropdown-list > div:hover {
  background: var(--light);
}

.lang-selector {
  max-height: 60vh;
  overflow: auto;
}

.dropdown:hover .dropdown-list,
.dropdown.open .dropdown-list {
  display: block;
  position: absolute;
  box-sizing: border-box;
  margin-top: -1px;
  left: 0;
  z-index: 9;
  background: var(--lighter);
  border: 1px solid var(--accent-1);
  width: 100%;
}

.dropdown.dropup .dropdown-list {
  bottom: 100%;
  margin-bottom: -1px;
  top: unset;
}

.dropdown:hover .dropdown-list > div,
.dropdown.open .dropdown-list > div {
  padding: 0.2rem 0.8rem;
}

.dropdown.centered-content:hover .dropdown-list > div,
.dropdown.centered-content.open .dropdown-list > div {
  padding: 0.2rem 0;
  text-align: center;
}

.dropdown:hover .dropdown-list > .active,
.dropdown.open .dropdown-list > .active {
  font-weight: 600;
}

.dropdown:hover .dropdown-list > div:hover,
.dropdown.open .dropdown-list > div:hover {
  background: var(--light);
}

#log {
  height: 0;
  max-height: 150px;
  background: var(--dark);
  overflow-y: auto;
  color: var(--light);
  display: flex;
  flex-direction: column-reverse;
  transition: 0.2s;
  padding: 0 0.8rem;
}

#log.open {
  height: auto;
  padding: 0.8rem;
}

.console-entry {
  display: flex;
  align-items: center;
}

.console-entry .label {
  margin-right: 0.4rem;
  line-height: normal;
}

.console-entry > *:not(.label) {
  height: 100%;
}

.big-number-list > * {
  display: flex;
}

/*.big-number-list > *:not(:first-child) {
        border-top: 1px solid var(--light);
    }*/

.big-number-list.sortable .big-number {
  cursor: ns-resize;
}

.big-number {
  padding: 0.8rem;
  font-size: 3rem;
  line-height: 2.6rem;
  margin-right: 0.8rem;
  color: var(--light);
  text-align: center;
}

.big-number i {
  display: block;
  font-size: 1.2rem;
  margin-top: 0.4rem;
}

.big-number-list:not(.no-hover) > *:hover .big-number,
.big-number.active {
  color: var(--accent-1);
  transition: 0.2s;
}

.big-number.passed {
  color: var(--passed);
}

.big-number.failed {
  color: var(--failed);
}

.big-number.info {
  color: var(--info);
}


.folder-structure {
}

.folder-structure .folder {
  margin-bottom: 0.4rem;
  cursor: pointer;
}

.folder-structure .folder:hover {
  color: var(--accent-2);
}

.folder-structure .folder.selected {
  color: var(--accent-1);
}

.folder-structure .folder.selected > i.icon-folder::before {
  content: "\\e95e";
}

.folder-structure .folder .folder {
  margin-left: 2rem;
}

.folder-structure .folder.no-expand i.icon-forward {
  visibility: hidden;
}

.folder-structure .folder.selected i.icon-forward {
  transform: rotate(90deg);
  display: inline-block;
  transition: 0.2s;
}

.scorm-preview,
.scorm-preview iframe,
.document-preview,
.document-preview iframe {
  width: 100%;
  height: 100%;
}


/* Modal */
.modal {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

.modal .navbar {
  margin-bottom: 0.8rem;
}

.modal .titlebar .navbar-section:first-child {
  font-size: 1rem;
}

#modal-bg {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: var(--bg);
  opacity: 0.8;
}

#modal-inner {
  max-width: 400px;
  max-height: 80%;
  margin: 0 auto;
  margin-top: 5%;
  background: var(--bg);
  border: 1px solid var(--dark);
  z-index: 1;
  position: relative;
  overflow-y: auto;
  border-radius: 0.2rem;
  padding: 2.4rem;
}

.modal-mid #modal-inner {
  min-width: 30%;
}

.modal-large #modal-inner {
  min-width: 40%;
}

.modal-wide #modal-inner {
  min-width: 60%;
}

.modal-big #modal-inner {
  min-width: 75%;
  min-height: 75%;
  display: flex;
  flex-direction: column;
}

.modal-huge #modal-inner {
  min-width: 90%;
  min-height: 85%;
  margin-top: 2%;
  display: flex;
  flex-direction: column;
}

.modal-big #modal-target,
.modal-huge #modal-target {
  display: flex;
  flex-direction: column;
  flex: auto;
}

.modal-fill-height #modal-target {
  flex-direction: row;
}

.modal .titlebar {
  display: flex;
  justify-content: space-between;
  padding-bottom: 1.4rem;
  border-bottom: 1px solid var(--lighter);
  box-sizing: border-box;
  text-transform: uppercase;
  font-weight: 500;
  font-size: 0.85rem;
  align-items: center;
}

.modal .titlebar-section {
  display: flex;
}

#modal-target,
.modal-target {
  padding-top: 1.4rem;
}

/* Toasts */

#toaster {
  display: flex;
  flex-direction: column;
  position: fixed;
  z-index: 500;
  bottom: 1rem;
  right: 1.8rem;
  min-width: 20vw;
  align-items: flex-end;
}

#toaster > .toast {
  margin-bottom: 10px;
  padding: 0.8rem;
  /*max-width: 50%;*/
  display: flex;
  justify-content: space-between;
  border-radius: 0.2rem;
  box-shadow: 0 3px 3px 0 rgba(0,0,0,0.2);
}

#toaster > .toast > button {
  float: right;
  border: none;
  padding: 0;
}

#toaster > .toast > button:hover {
  background: unset;
}

#toaster > .toast.toast-success {
  background: var(--passed);
  color: #fff;
}

#toaster > .toast.toast-error {
  background: var(--failed);
  color: #fff;
}

#toaster > .toast.toast-info {
  background: var(--info);
  color: #fff;
}

#toaster > .toast.toast-warn {
  background: var(--warn);
  color: #111;
}

#toaster > .toast i {
  /*color: var(--light);*/
  font-weight: bold;
  display: flex;
  /*align-items: center;*/
}

#toaster > .toast:not(.toast-ghost) {
  animation: toast-fadein 0.75s;
}

#toaster > .toast h6 {
  margin-bottom: 0;
}

.toast-ghost {
  opacity: 0.5;
}

@keyframes toast-fadein {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

/* Loading */

.loading-bar {
  height: 5px;
  border: 1px solid var(--accent-1);
  position: relative;
}

.loading-width {
  background: var(--accent-1);
  height: 100%;
  width: 0;
}

.loading-dots {
  display: inline-block;
}

.loading-dots:after {
  color: var(--light);
  display: inline-block;
  content: "";
  animation-name: loading-dots-keyframes;
  animation-duration: 2s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}

@keyframes loading-dots-keyframes {
  0% {
    content: "\\a0\\a0\\a0"
  }

  33% {
    content: ".\\a0\\a0"
  }

  66% {
    content: "..\\a0"
  }

  99% {
    content: "..."
  }
}

/*.loading {
    pointer-events: none;
}

    .loading > i {
        color: transparent !important;
        min-height: .8rem;
        pointer-events: none;
        position: relative;
    }

        .loading > i::before {
            display: none;
        }

        .loading > i::after {
            animation: loading .5s infinite linear;
            background: 0 0;
            border: 1px solid var(--dark);
            border-radius: 50%;
            border-right-color: transparent;
            border-top-color: transparent;
            content: "";
            display: inline-block;
            height: 0.8rem;
            opacity: 1;
            padding: 0;
            width: 0.8rem;
            z-index: 1;
            margin: 0 0.2rem;
        }

    .loading.loading-big i::after {
        height: 3rem;
        width: 3rem;
    }

@keyframes loading {
    0% {
        transform: rotate(0)
    }

    100% {
        transform: rotate(360deg)
    }
}*/

/* Loading 2 */

.loading {
  display: block;
  position: absolute;
  top: 20%;
  left: 50%;
  height: 50px;
  width: 50px;
  margin: -25px 0 0 -25px;
}

.loading span {
  position: absolute;
  display: block;
  bottom: 10px;
  width: 9px;
  height: 15px;
  background: var(--accent-1);
  opacity: 0.25;
  -webkit-animation: loading 2s infinite ease-in;
  animation: loading 2s infinite ease-in;
}

.loading.loading-invert span {
  background: var(--text) !important;
}

.loading span:nth-child(2) {
  left: 11px;
  -webkit-animation-delay: 0.2s;
  animation-delay: 0.2s;
}

.loading span:nth-child(3) {
  left: 22px;
  -webkit-animation-delay: 0.4s;
  animation-delay: 0.4s;
}

.loading span:nth-child(4) {
  left: 33px;
  -webkit-animation-delay: 0.6s;
  animation-delay: 0.6s;
}

.loading span:nth-child(5) {
  left: 44px;
  -webkit-animation-delay: 0.8s;
  animation-delay: 0.8s;
}

.loading.loading-inline {
  position: static;
  height: 50px;
  width: unset;
  margin: auto;
  text-align: center;
}

.loading.loading-inline span {
  position: static;
  display: inline-block;
  margin-right: 2px;
}

@keyframes loading {
  0% {
    background: var(--accent-1);
    opacity: 0.25;
  }

  25% {
    background: var(--accent-1);
    opacity: 1;
  }

  50% {
    background: var(--accent-1);
    opacity: 0.25;
  }

  100% {
    background: var(--accent-1);
    opacity: 0.25;
  }
}

@-webkit-keyframes loading {
  0% {
    background: var(--accent-1);
    opacity: 0.25;
  }

  25% {
    background: var(--accent-1);
    opacity: 1;
  }

  50% {
    background: var(--accent-1);
    opacity: 0.25;
  }

  100% {
    background: var(--accent-1);
    opacity: 0.25;
  }
}

.loading.input-loading {
  position: absolute;
  top: 8px;
  left: unset;
  right: 12px;
}

/* --- */

.colour-picker {
}

.colour-picker .text-toggle,
.colour-picker .pick-colour {
  background: var(--light);
  padding: 0 0.5rem;
  display: flex;
  align-items: center;
  border-radius: 0.1rem 0 0 0.1rem;
  cursor: pointer;
}

.colour-picker .pick-colour {
  border-radius: 0 0.1rem 0.1rem 0;
}

.colour-picker .text-toggle:hover,
.colour-picker .pick-colour:hover {
  background: var(--light);
}

.colour-picker .swatches {
  text-align: right;
  border-top: none;
  padding-top: 0.2rem;
}

.colour-picker .swatches span {
  cursor: pointer;
  border-radius: 0.1rem;
  display: inline-block;
  width: 1.6rem;
  height: 1.6rem;
  margin: 0.2rem;
}


/* style.css*/

.org-box-list {
  display: flex;
  flex-wrap: wrap;
  padding: 1.6rem;
  align-content: flex-start;
  overflow-y: auto;
}

.org-box-list > div {
  width: 250px;
  padding: 0.8rem;
  box-sizing: border-box;
}

.org-box-list > div > div {
  border-radius: 0.1rem;
  min-height: 250px;
  overflow: hidden;
  border: 1px solid var(--light);
}

.org-box-list > div > div .padding {
  padding: 0.8rem;
}

.org-box-list .img {
  width: 100%;
  height: 165px;
  background: var(--lighter);
  display: flex;
  align-items: center;
}

.org-box-list .img img {
  max-height: 80%;
  max-width: 80%;
  margin: 0 auto;
}

.centre-content {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
}

.hyperlink {
  color: var(--hyperlink-blue) !important;
}

.hyperlink:hover {
  text-decoration: underline;
}

.hyperlink-original {
  text-decoration: underline;
  color: var(--hyperlink-blue) !important;
}

.small-font {
  font-size: small !important;
}

/* Chrome, Safari, Edge, Opera */
.phoneNo > input::-webkit-outer-spin-button,
 input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
.mobileNo > input[type=number] {
  -moz-appearance: textfield;
}

.phoneNumber  {
  pattern: 0-9;
}

.courseDescription a {
  color: #0052CC; /* Custom color for hyperlinks */
}

.courseDescription a:hover {
  color: #0052CC; /* Color on hover */
  text-decoration: underline;
}

.text-editor .input.richtext i,
.courseDescription i,
.instructions i, .richtext i {
  font-style: italic !important;
  font-family: inherit !important;
  font-size: inherit !important;
}

.instructions b, .richtext b {
  font-weight: bolder !important;
}

a.hyperlink.disabled {
    pointer-events: none;
    color: gray;
    text-decoration: none;
    cursor: default;
    opacity: 0.6;
}

/* Container section for form rows */

/* Flex row utilities */
.flex-row {
    display: flex;
    flex-direction: row;
}

.items-center {
    display: flex;
    align-items: center;
}

.justify-between {
    display: flex;
    justify-content: space-between;
}

/* Left-side labels */
.text-bolder {
    font-weight: 600; /* bold text */
    margin-bottom: 0.25rem;
}

/* Gray/disabled text */
.text-gray {
    color: #a0a0a0;
}


.input-small {
    width: 40px;
    padding: 0.25rem 0.5rem;
    font-size: 0.875rem;
    border: 1px solid #ccc;
    border-radius: 4px;
}
.right-side {
    display: flex;
    flex-direction: column;  /* stack vertically */
    justify-content: space-between; /* toggle top, input bottom */
    align-items: flex-end; /* align to the right */

}

.input-small {
    width: 60px !important;
    padding: 0.25rem 0.5rem;
    font-size: 0.875rem;
}

.input-small:disabled {
    color: #a0a0a0;  /* or text-gray from your Tailwind/variable */
    background-color: #f5f5f5; /* optional, to indicate disabled visually */
    cursor: not-allowed;       /* optional, shows the disabled cursor */
}

.btn-info {
  color: var(--avetta-blue);
  border: 1px solid var(--avetta-blue);
}

.btn-info:hover {
  color: var(--lighter);
  background: var(--avetta-blue);
}

.btn-cta.btn-info,
.btn-cta.btn-info:hover {
  background: var(--avetta-blue);
  border: 1px solid var(--avetta-blue);
  color: var(--lighter);
}

.btn.btn-md {
  min-width: 150px !important;
}
.btn.btn-lg {
  min-width: 200px !important;
}

`, "",{"version":3,"sources":["webpack://./src/styles/styles.css"],"names":[],"mappings":";AACA,mBAAmB;;AAEnB;EACE,UAAU;EACV,aAAa;EACb,oBAAoB;EACpB,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;EACzB,oBAAoB;EACpB,eAAe;EACf,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;EACzB,oBAAoB;EACpB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;EAChC,sBAAsB;EACtB,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA,sBAAsB;;AAEtB;EACE,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,8FAA8F;EAC9F,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA,mBAAmB;;AAEnB;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;;AAGA,oBAAoB;;AAEpB;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,YAAY;EACZ,kCAAkC;EAClC,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,iBAAiB;EACjB,sCAAsC;EACtC,mCAAmC;EACnC,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wBAAwB;AAC1B;;;AAGA;;;EAGE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;EACX,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,SAAS;AACX;;AAEA;;;EAGE,UAAU;AACZ;;AAEA;;;EAGE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;;AAGA,oBAAoB;;AAEpB;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,8BAA8B;EAC9B,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,qBAAqB;AACvB;;AAEA,+BAA+B;;AAE/B;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,OAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;;EAEnB;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,UAAU;EACV,8BAA8B;EAC9B,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;EACnB,kCAAkC;EAClC,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;;EAEd,WAAW;EACX,kBAAkB;EAClB,kCAAkC;EAClC,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,8BAA8B;EAC9B,4BAA4B;EAC5B,2BAA2B;EAC3B,gCAAgC;EAChC,4BAA4B;EAC5B,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;EAC3B,uBAAuB;EACvB,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,iCAAiC;EACjC,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;EAIE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;;AAGA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,iCAAiC;EACjC,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;;EAEE,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,OAAO;EACP,QAAQ;EACR,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,mCAAmC;AACrC;;AAEA;;;MAGM;;AAEN;EACE,YAAY;EACZ,8BAA8B;EAC9B,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,qCAAqC;EACrC,wBAAwB;EACxB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;;;;;;;UAQU;;AAEV;EACE,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;;EAEE,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,mBAAmB,GAAG,gBAAgB;EACtC,cAAc;AAChB;;AAEA;EACE,mBAAmB,GAAG,eAAe;EACrC,cAAc;AAChB;;AAEA;EACE,mBAAmB,GAAG,eAAe;EACrC,cAAc;AAChB;;AAEA;EACE,mBAAmB,GAAG,oBAAoB;EAC1C,cAAc;AAChB;;AAEA;EACE,mBAAmB,GAAG,iBAAiB;EACvC,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB,EAAE,6BAA6B;EACtD,WAAW,EAAE,iCAAiC;AAChD;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;EACxB,cAAc;EACd,eAAe,EAAE,0CAA0C;AAC7D;;AAEA;;;EAGE,oCAAoC;AACtC;;AAEA;;;EAGE,oCAAoC;AACtC;;AAEA;;;EAGE,kCAAkC;AACpC;;AAEA;;;EAGE,kCAAkC;AACpC;;AAEA;;;EAGE,oCAAoC;AACtC;;AAEA;;;EAGE,oCAAoC;AACtC;;AAEA;;;EAGE,kCAAkC;AACpC;;AAEA;;;EAGE,kCAAkC;AACpC;;AAEA;;EAEE,iBAAiB;AACnB;AACA;;EAEE,iBAAiB;AACnB;AACA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;EAC1C,4CAA4C;AAC9C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;;;;EAIE,6BAA6B;EAC7B,0BAA0B;EAC1B,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,iCAAiC;EACjC,aAAa;AACf;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;;EAGE,WAAW;EACX,eAAe;AACjB;;AAEA;;;EAGE,iCAAiC;AACnC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,OAAO;EACP,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,mBAAmB;;EAEnB;IACE,aAAa;;IAEb;MACE,YAAY;IACd;;IAEA;;OAEG;;IAEH;MACE,WAAW;MACX,kBAAkB;IACnB,CAAA;;IAED;MACE,UAAU;IACZ;EACF;AACF;;;AAGA,6BAA6B;;AAE7B;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,cAAc;EACd,cAAc;EACd,qBAAqB;EACrB,6BAA6B;EAC7B,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;EACtB,uCAAuC;EACvC,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,6BAA6B;EAC7B,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,6BAA6B;EAC7B,mBAAmB;EACnB,cAAc;EACd,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX;AACF;;AAEA;EACE,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,0CAA0C;;AAE1C;EACE,aAAa;EACb,iCAAiC;EACjC,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,eAAe;EACf,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,WAAW;EACX,iCAAiC;EACjC,gCAAgC;EAChC,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B;AACF;;AAEA,wBAAwB;;AAExB;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,WAAW;EACX,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,MAAM;EACN,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,QAAQ;AACV;;AAEA;;EAEE,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;;EAEE,WAAW;AACb;;AAEA;;;EAGE,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,+BAA+B;;AAE/B;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,gBAAgB;EAChB,8BAA8B;EAC9B,sBAAsB;EACtB,4BAA4B;EAC5B,kBAAkB;EAClB,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;;EAEE,aAAa;AACf;;;AAGA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,YAAY;AACd;;AAEA,UAAU;;AAEV,YAAY;AACZ;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,aAAa;EACb,qBAAqB;EACrB,2BAA2B;EAC3B,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,oBAAoB;EACpB,oBAAoB;EACpB,kBAAkB;EAClB,uBAAuB;EACvB,iCAAiC;EACjC,sCAAsC;EACtC,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,YAAY;;AAEZ;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,oBAAoB;EACpB,iCAAiC;EACjC,iBAAiB;EACjB,uBAAuB;EACvB,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA;;EAEE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,4BAA4B,uBAAuB,CAAC;;AAEpD;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,mBAAmB,sBAAsB,CAAC;;AAE1C,OAAO,cAAc,CAAC;;AAEtB;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;;EAGE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;;;;;;;;;;;EAWE,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;;;AAGA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB,EAAE,4BAA4B;AACnD;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB;EACpB,WAAW,EAAE,2BAA2B;AAC1C;;AAEA;EACE,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;;EAEE,yBAAyB;EACzB,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;EACzB,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;;EAEE,uBAAuB;EACvB,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;;EAEE,uBAAuB;EACvB,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA,mBAAmB;;AAEnB;EACE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;;;EAIE,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE;IACE,0CAA0C;EAC5C;;EAEA;IACE,0CAA0C;EAC5C;AACF;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,+BAA+B;EAC/B,cAAc;EACd,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,UAAU;EACV,oBAAoB;EACpB,wBAAwB;EACxB,mBAAmB;EACnB,cAAc;EACd,2BAA2B;EAC3B,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,0BAA0B;EAC1B,cAAc;EACd,qBAAqB;EACrB,WAAW;EACX,kCAAkC;EAClC,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,sCAAsC;EACtC,mCAAmC;EACnC,kCAAkC;EAClC,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,aAAa,eAAe,4BAA4B;EACxD,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;;;;;;EAME,aAAa;AACf;;AAEA;EACE,4NAA4N;EAC5N,4BAA4B;EAC5B,wBAAwB;EACxB,mEAAmE;EACnE,6BAA6B;EAC7B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,oCAAoC;EACpC,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,oCAAoC;EACpC,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;;EAEE,wCAAwC;EACxC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,iBAAiB;EACjB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,OAAO;EACP,UAAU;EACV,0BAA0B;EAC1B,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,OAAO;EACP,UAAU;EACV,0BAA0B;EAC1B,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,UAAU;AACZ;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;EAEE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;;MAEM;;AAEN;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;;AAGA;AACA;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;;;EAIE,WAAW;EACX,YAAY;AACd;;;AAGA,UAAU;AACV;EACE,eAAe;EACf,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,cAAc;EACd,qBAAqB;EACrB,6BAA6B;EAC7B,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;EACtB,uCAAuC;EACvC,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA,WAAW;;AAEX;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA,YAAY;;AAEZ;EACE,WAAW;EACX,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,sCAAsC;EACtC,sBAAsB;EACtB,mCAAmC;EACnC,iCAAiC;AACnC;;AAEA;EACE;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE;EACF;AACF;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA6CE;;AAEF,cAAc;;AAEd;EACE,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,2BAA2B;EAC3B,aAAa;EACb,8CAA8C;EAC9C,sCAAsC;AACxC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,UAAU;EACV,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE;IACE,2BAA2B;IAC3B,aAAa;EACf;;EAEA;IACE,2BAA2B;IAC3B,UAAU;EACZ;;EAEA;IACE,2BAA2B;IAC3B,aAAa;EACf;;EAEA;IACE,2BAA2B;IAC3B,aAAa;EACf;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,aAAa;EACf;;EAEA;IACE,2BAA2B;IAC3B,UAAU;EACZ;;EAEA;IACE,2BAA2B;IAC3B,aAAa;EACf;;EAEA;IACE,2BAA2B;IAC3B,aAAa;EACf;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,WAAW;AACb;;AAEA,QAAQ;;AAER;AACA;;AAEA;;EAEE,wBAAwB;EACxB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,qBAAqB;EACrB,aAAa;EACb,cAAc;EACd,cAAc;AAChB;;;AAGA,aAAa;;AAEb;EACE,aAAa;EACb,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,uCAAuC;AACzC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,gCAAgC;AAChC;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc,EAAE,gCAAgC;AAClD;;AAEA;EACE,cAAc,EAAE,mBAAmB;EACnC,0BAA0B;AAC5B;;AAEA;;;EAGE,6BAA6B;EAC7B,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;IACI,oBAAoB;IACpB,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,YAAY;AAChB;;AAEA,oCAAoC;;AAEpC,uBAAuB;AACvB;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA,qBAAqB;AACrB;IACI,gBAAgB,EAAE,cAAc;IAChC,sBAAsB;AAC1B;;AAEA,uBAAuB;AACvB;IACI,cAAc;AAClB;;;AAGA;IACI,WAAW;IACX,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,sBAAsB,GAAG,qBAAqB;IAC9C,8BAA8B,EAAE,6BAA6B;IAC7D,qBAAqB,EAAE,uBAAuB;;AAElD;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,cAAc,GAAG,6CAA6C;IAC9D,yBAAyB,EAAE,4CAA4C;IACvE,mBAAmB,QAAQ,wCAAwC;AACvE;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;;EAEE,8BAA8B;EAC9B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B","sourcesContent":["\n/* --- THEMES --- */\n\n:root[theme=\"light\"] {\n  --bg: #fff;\n  --white: #fff;\n  --font-dark: #15304f;\n  --font-light: #858896;\n  --border: #dddddd;\n  --secondary: #e9e9e9;\n  --secondary-dark: #d6d6d6;\n  --lighter-2: #a2a9b6;\n  --dark: #272B2C;\n  --light: #ddd;\n  --lighter: #eee;\n  --accent-1: #101828;\n  --accent-2: #2f2f2f;\n  --hyperlink-blue: blue;\n  --avetta-blue: #0c2a4a;\n  --avetta-blue-dark: #042344;\n  --info: #0288d1;\n  --primary: #085d49;\n  --passed: #09de71;\n  --success: #09de71;\n  --warn: #ffa937;\n  --error: #de3730;\n  --failed: #de3730;\n  --textbase: #101828;\n  --primarybg: #dcfaec;\n}\n\n:root[theme=\"dark\"] {\n  --bg: #333;\n  --white: #222425;\n  --font-dark: #b3b1ab;\n  --font-light: #979086;\n  --border: #373b3c;\n  --secondary: #2d3032;\n  --secondary-dark: #373b3c;\n  --lighter-2: #2b2d2f;\n  --dark: #eee;\n  --light: #555;\n  --lighter: #444;\n  --accent-1: #efefef;\n  --accent-2: #eee;\n  --hyperlink-blue: cornflowerblue;\n  --avetta-blue: #8b9fb4;\n  --avetta-blue-dark: #7994b1;\n  --info: #0288d1;\n  --primary: #085d49;\n  --passed: #09de71;\n  --success: #09de71;\n  --warn: #ffa937;\n  --error: #de3730;\n  --failed: #de3730;\n  --textbase: #101828;\n  --primarybg: #dcfaec;\n}\n\n#theme-toggle {\n  width: 15px;\n  height: 15px;\n  border-radius: 5px;\n  background: var(--dark);\n  cursor: pointer;\n  transition: 0.3s;\n}\n\n/* --- OVERRIDES --- */\n\nhtml, body {\n  height: 100%;\n  margin: 0;\n  color: var(--dark);\n  font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Ubuntu,sans-serif;\n  font-weight: normal;\n  font-size: 0.95rem;\n  background: var(--bg);\n  overflow-x: hidden;\n}\n\nh1, h2, h3, h4, h5, h6 {\n  margin: 0;\n  font-weight: 600;\n}\n\nh1 {\n  margin: 0;\n}\n\n::placeholder {\n  color: var(--dark);\n}\n\n.form-section ::placeholder {\n  color: #999;\n}\n\n/* --- LAYOUT --- */\n\nmain {\n  display: flex;\n  flex-direction: row;\n  height: 100%;\n}\n\n\n/* --- SIDEBAR --- */\n\n#sidebar-wrapper {\n  width: 250px;\n  min-width: 250px;\n  position: relative;\n}\n\n#sidebar {\n  position: fixed;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 250px;\n  min-width: 250px;\n  overflow: hidden;\n  overflow-y: auto;\n  top: 10px;\n  height: 100%;\n  border-right: 1px solid var(--lighter);\n}\n\n.sidebar-section {\n  padding: 1.6rem;\n  box-sizing: border-box;\n}\n\n.sidebar-section button {\n  line-height: 1;\n  height: auto;\n}\n\n#sidebar > div > div img {\n  max-height: 60px;\n  max-width: 100%;\n}\n\n#sidebar > div > div * {\n  /*display: block;*/\n  margin-bottom: 0.8rem;\n}\n\n#sidebar > div > ul {\n  margin-top: 1.6rem;\n}\n\n#sidebar ul ul {\n  margin-top: 0.8rem;\n}\n\n#sidebar li {\n  list-style: none;\n  margin-bottom: 0.8rem;\n  transition: 0.1s;\n}\n\n#sidebar li:only-child {\n  margin-bottom: 0;\n}\n\n#sidebar ul > li > ul > li > ul > li {\n  margin-left: 0.8rem;\n}\n\n#sidebar ul > li > ul > li > ul > li > ul > li {\n  margin-left: 0.8rem;\n}\n\n#sidebar ul > li > ul > li > ul > li > ul > li > ul > li {\n  margin-left: 0.8rem;\n}\n\n#sidebar ul ul {\n  margin-left: 0.8rem;\n}\n\n#sidebar li.accordion {\n  position: relative;\n}\n\n#sidebar li.accordion::after {\n  content: '\\e975';\n  display: inline-block;\n  position: absolute;\n  right: 0;\n  top: 0;\n  opacity: 0.5;\n  font-family: 'spudfont' !important;\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 30px;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  font-size: 1.2rem;\n}\n\n#sidebar li.accordion:hover::after {\n  opacity: 1;\n}\n\n#sidebar li.accordion.open::after {\n  transform: rotate(90deg);\n}\n\n\n#sidebar button,\n#sidebar .button,\n#sidebar a {\n  border: none;\n  outline: none;\n  background: transparent;\n  text-align: left;\n  width: 100%;\n  padding: 0;\n  cursor: pointer;\n  color: var(--dark);\n  font-family: inherit;\n  font-weight: normal;\n  font-size: 0.975rem;\n  opacity: 0.7;\n  margin: 0;\n}\n\n#sidebar button:hover,\n#sidebar .button:hover,\n#sidebar a:hover {\n  opacity: 1;\n}\n\n#sidebar button.selected,\n#sidebar .button.selected,\n#sidebar a.selected {\n  font-weight: 600;\n  opacity: 1;\n}\n\n.accordion > ul {\n  display: none;\n}\n\n.accordion.open > ul {\n  display: block;\n}\n\n#sidebar .accordion button {\n  padding-right: 20px;\n}\n\n#sidebar .accordion a {\n  padding-right: 20px;\n}\n\n\n/* --- CONTENT --- */\n\n#content {\n  flex: auto;\n  display: flex;\n  flex-direction: column;\n  background: var(--bg);\n}\n\n.content-box {\n  padding: 2.5rem 4.5rem;\n  box-sizing: border-box;\n}\n\n.centered-layout .content-box {\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.content-box:not(:last-child) {\n  border-bottom: 1px solid var(--lighter);\n}\n\n.toolbar {\n  display: flex;\n  flex-direction: row;\n  box-sizing: border-box;\n  justify-content: space-between;\n  padding: 0;\n  margin-bottom: 0.8rem;\n}\n\nfooter.toolbar {\n  margin-bottom: 0;\n}\n\n.content-box .toolbar:only-child {\n  margin: 0;\n}\n\n.content-box h3 {\n  margin-bottom: 0.8rem;\n}\n\n/* -------------------------- */\n\n#page-wrapper {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  margin: 0;\n  overflow: hidden;\n}\n\n.page-wrapper {\n  display: flex;\n  justify-content: center;\n}\n\n.page-centered {\n  max-width: 960px;\n  flex: 1;\n}\n\n#page {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  height: 100%;\n}\n\n.relative {\n  position: relative;\n}\n\n#login-form-container {\n  margin-top: auto !important;\n  margin-bottom: auto !important;\n}\n\nheader {\n  /*align-content: flex-start;*/\n}\n\n#auth-left {\n  flex: 35%;\n  min-width: 300px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  overflow: hidden;\n  overflow-y: auto;\n  height: 100vh;\n  padding: 1.6rem;\n  box-sizing: border-box;\n  background: var(--bg);\n}\n\n#auth-left > *:first-child {\n  width: 100%;\n  max-width: 300px;\n  margin-top: 20%;\n  align-self: center;\n}\n\n.splash-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  .form-label {\n    font-weight: bold;\n  }\n}\n\n.splash-container .form-logo-container {\n  width: 50%;\n  margin-bottom: 10px !important;\n  text-align: center;\n  justify-content: center;\n}\n\n#auth-left .form-logo-container {\n  text-align: center;\n  margin-bottom: 4rem;\n}\n\n#auth-left .form-logo-container img {\n  max-height: 80px;\n  max-width: 100%;\n  margin: 0 auto;\n}\n\n.company-tagline {\n  text-align: center;\n  color: var(--avetta-blue);\n}\n\n#sign-in-text {\n  margin: 20px 0px;\n  font-weight: bold;\n  font-size: 22px;\n}\n\n.fill-width {\n  width: 100% !important;\n}\n\n.splash-container .lang-container{\n  text-align: left;\n}\n\n.splash-container .fill-width .dropdown button{\n  width: 100%;\n  justify-content: space-between;\n  align-items: center;\n  background-color: var(--secondary);\n  border: none;\n  color: var(--font-dark);\n  font-weight: 400;\n  font-size: 13px;\n}\n\n.avetta-blue-heading {\n  text-align: center;\n  color: var(--avetta-blue-dark);\n}\n\n.primary-btn{\n  background-color: #00a26a !important;\n}\n\n.splash-container .or-line {\n  color: #c6d1df;\n  ;\n  width: 100%;\n  text-align: center;\n  border-bottom: 1.2px solid #c6d1df;\n  line-height: 0.1em;\n  margin: 30px 0;\n}\n\n.splash-container .or-line span {\n  background: var(--bg);\n  padding: 0 10px;\n}\n\n.splash-container .login-as-visitor {\n  background-color: #005cff;\n}\n\n.splash-container .contact-our-team {\n  margin: 35px 0 10px !important;\n}\n\n.contact-our-team {\n  text-align: center !important;\n  align-items: center !important;\n  margin: 10px 0 10px !important;\n  font-size: 0.9rem !important;\n  font-weight: 400 !important;\n  border: solid #edf0f6 !important;\n  border-width: 1px !important;\n  padding: 1.5rem 0 !important;\n  color: #0c2a4a;\n}\n\n.contact-our-team svg {\n  margin: -5px auto 0;\n  display: block;\n  width: 40%;\n  padding: 0;\n}\n\n.full-btn {\n  text-align: center !important;\n  color: #fff !important;\n  font-size: 0.9rem !important;\n  font-weight: 400 !important;\n  height: 40px !important;\n  border-radius: 8px !important;\n  border-width: 0 !important;\n}\n\n#activate-peg-account {\n  text-align: center;\n  min-width: 320px;\n  width: unset !important;\n  max-width: unset !important;\n  margin-top: 20px !important;\n}\n\n#verify-sso-outer {\n  flex: 35%;\n  min-width: 300px;\n  display: flex;\n  flex-direction: column;\n  row-gap: 30px;\n  align-items: center;\n  overflow: hidden;\n  overflow-y: auto;\n  height: 100vh;\n  padding: 1.6rem;\n  box-sizing: border-box;\n  background: #ffffff;\n}\n\n.verify-sso-container {\n  max-width: 320px !important;\n  display: flex;\n  flex-direction: column;\n  row-gap: 35px;\n  text-align: center;\n}\n\n#auth-left .form-header {\n  margin-bottom: 0.8rem;\n  font-weight: 500;\n  font-size: 1.2rem;\n}\n\n#auth-left .form-section {\n  margin-bottom: 0.8rem;\n}\n\n#auth-right {\n  flex: 65%;\n  background-size: cover !important;\n  background-position: center !important;\n  background: var(--lighter);\n}\n\nul {\n  margin: 0;\n  padding: 0;\n}\n\n.richtext ul {\n  margin: 1rem;\n  padding: 0 1rem;\n}\n\n.text-colour {\n  color: var(--text);\n}\n\na,\na:visited,\na:active,\na:focus {\n  text-decoration: none;\n  color: inherit;\n}\n\ni {\n  font-size: 1rem;\n}\n\ni.rotate-90::before {\n  display: inline-block;\n  transform: rotate(90deg);\n}\n\ni.rotate-180::before {\n  display: inline-block;\n  transform: rotate(180deg);\n}\n\n\ni.rotate-270::before {\n  display: inline-block;\n  transform: rotate(270deg);\n}\n\nhr {\n  border: none;\n  border-top: 1px solid var(--light);\n}\n\niframe {\n  border: none;\n}\n\n.top-0 {\n  top: 0 !important;\n}\n\n.border-radius-default {\n  border-radius: 0.1rem;\n}\n\n.logo-preview {\n  max-width: 100%;\n  height: 80px;\n  display: block;\n  /*margin: 0 auto;*/\n}\n\n#menu {\n  width: 200px;\n  border-right: 1px solid var(--dark);\n}\n\n.content-wrapper {\n  flex: 1 auto;\n  flex-direction: column;\n  display: flex;\n  align-items: stretch;\n}\n\n.content {\n  flex: 1 auto;\n  width: 100%;\n}\n\n.content-wrapper:not(:first-child) {\n  border-left: 1px solid var(--light);\n}\n\n#console {\n  height: 100px;\n  margin-top: 0.8rem;\n}\n\n#console ul {\n  height: 100%;\n  overflow-y: auto;\n  flex-direction: column-reverse;\n  display: flex;\n}\n\n.panel-box {\n  box-sizing: border-box;\n  height: 100%;\n  width: 100%;\n  position: relative;\n  align-content: flex-start;\n}\n\n.panel-box-border-right {\n  border-right: 1px solid var(--dark);\n}\n\n.panel-box-toolbar {\n  height: 20px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  background: var(--light);\n  line-height: 20px;\n}\n\n.panel-box-toolbar > * {\n  height: 100%;\n}\n\n.panel-box-content {\n  overflow: hidden;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.panel-box-content > * {\n  flex: 1 auto;\n}\n\n.panel-box-content > *:not(:first-child) {\n  border-left: 1px solid var(--light);\n}\n\n.page-content {\n  position: relative;\n}\n\n.page-content .toolbar {\n  border: none;\n}\n\n.page-content .toolbar .tab {\n  padding: 0 0.8rem;\n}\n\n.page-content .toolbar.tab:hover {\n  background: var(--accent-1);\n  color: var(--lighter);\n}\n\n.page-content .toolbar .tab.active {\n  background: var(--lighter);\n  pointer-events: none;\n}\n\n.page-content .toolbar input {\n  /*color: var(--dark);*/\n  background: var(--lighter);\n  border: 1px solid var(--accent-1);\n  border-radius: 0.2rem;\n  padding-left: 0.8rem;\n}\n\n.page-content .toolbar input:focus,\n.page-content .toolbar input:not(:placeholder-shown) {\n  /*background: var(--light);*/\n  /*color: var(--lighter);*/\n}\n\n.page-content-inner {\n  position: absolute;\n  top: 30px;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  /*padding: 0 0.4rem 0.4rem 0;*/\n  display: flex;\n}\n\n.page-content-inner .toolbar {\n  border-top: 1px solid var(--lighter);\n}\n\n.page-content-inner .padding {\n  padding: 0.8rem;\n}\n\n.page-content-inner > *:first-child:last-child {\n  flex: auto;\n}\n\n.page-content-inner > *:first-child:not(:last-child) {\n  flex: 30%;\n}\n\n.page-content-inner > *:last-child:not(:first-child) {\n  flex: 70%;\n  background: var(--lighter);\n  border-left: 1px solid var(--light);\n}\n\n/*.page-content-inner table:not(.sortable-table) th:first-child,\n    .page-content-inner table:not(.sortable-table) td:first-child {\n        padding-left: 0.8rem;\n    }*/\n\n.page-content-box {\n  margin: 1rem;\n  border: 1px solid var(--light);\n  border-radius: 0.2rem;\n  overflow: hidden;\n  overflow-y: auto;\n  flex: auto;\n}\n\n.content-box-header {\n  padding: 0.2rem 0.8rem;\n  border-bottom: 1px solid var(--light);\n  background: var(--light);\n  text-transform: uppercase;\n  font-size: 0.85rem;\n}\n\n.content-box-content {\n  padding: 0.8rem;\n}\n\n.content-container {\n  height: 100%;\n  overflow: auto;\n}\n\n.tab {\n  padding: 0 0.4rem;\n  white-space: nowrap;\n}\n\n.tab:not(.active) {\n  cursor: pointer;\n}\n\n.tab.focus {\n  background: var(--dark);\n  color: var(--light);\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row;\n}\n\n.flex-auto {\n  flex: auto;\n}\n\n.flex-float-left {\n  margin-right: auto !important;\n}\n\n.flex-float-right {\n  margin-left: auto !important;\n}\n\n.flex-fit-content {\n  flex: initial;\n}\n\n.flex-horizontal-content {\n  display: flex;\n  justify-content: space-between;\n}\n\n.center-content {\n  justify-content: center;\n  align-items: center;\n}\n\n.justify-between {\n  justify-content: space-between;\n}\n\n.align-center {\n  align-items: center;\n}\n\n.align-middle {\n  vertical-align: middle;\n}\n\n.align-left {\n  text-align: left !important;\n}\n\n.full-height {\n  height: 100%;\n  max-height: none !important;\n}\n\n.full-width {\n  width: 100%;\n  max-width: none !important;\n}\n\n.min-height-default {\n  min-height: 50vh;\n}\n\n.hidden {\n  display: none;\n}\n\n.translucent {\n  opacity: 0.5;\n}\n\n.break-word,\n.break-word * {\n  word-break: break-word;\n}\n\n.arrow-forward {\n  font-size: 0.8rem;\n  transform: rotate(180deg);\n  display: inline-block;\n  vertical-align: middle;\n  margin: 0 0.4rem;\n}\n\ntable {\n  text-align: left;\n  border-collapse: collapse;\n}\n\ntr {\n  height: 2.4rem;\n}\n\nth {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  font-weight: 500;\n  text-transform: uppercase;\n  background: var(--bg);\n  box-shadow: 0 2px 0 var(--border);\n  font-size: 0.85rem;\n}\n\ntable tbody tr {\n  border-bottom: 1px solid var(--light);\n}\n\ntable:not(.no-hover) tbody tr:hover {\n  background: var(--lighter);\n}\n\n/* table:not(.no-hover) tbody tr:hover a,\n        table:not(.no-hover) tbody tr:hover button {\n            color: var(--text);\n        }\n\n        table:not(.no-hover) tbody tr:hover .label {\n            background: none !important;\n            color: var(--text);\n        }*/\n\ntable.fixed-table {\n  table-layout: fixed;\n}\n\ntable.ellipsis th:not(:first-child):not(:last-child),\ntable.ellipsis td:not(:first-child):not(:last-child) {\n  padding: 0.4rem;\n}\n\ntable.ellipsis th:first-child,\ntable.ellipsis td:first-child {\n  padding-top: 0.4rem;\n  padding-right: 0.4rem;\n  padding-bottom: 0.4rem;\n}\n\ntable.ellipsis th:last-child,\ntable.ellipsis td:last-child {\n  padding-top: 0.4rem;\n  padding-left: 0.4rem;\n  padding-bottom: 0.4rem;\n}\n\ntable.ellipsis td,\ntable.ellipsis td a {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\ntable.activity-table tr:hover td {\n  overflow: auto;\n  white-space: normal;\n  background: var(--light);\n  cursor: default;\n}\n\ntable.sortable-table th:last-child {\n  width: 2.4rem;\n}\n\ntable.sortable-table td:last-child {\n  padding: 0 0.8rem;\n}\n\ntable.sortable-table td:last-child i {\n  cursor: ns-resize;\n}\n\ntd a {\n  display: block;\n  color: inherit;\n  padding-top: 0.2rem;\n  padding-bottom: 0.2rem;\n}\n\ntd button {\n  display: inline-block;\n}\n\ntd button:not(:first-child) {\n  margin-left: 0.4rem;\n}\n\n.table-wrapper {\n  overflow: hidden;\n  overflow-y: auto;\n}\n\n.modal .table-wrapper {\n  max-height: 50vh;\n}\n\n.modal .table-wrapper th {\n  background: var(--bg);\n}\n\n.page-content .toolbar.table-footer,\n.table-footer {\n  margin-top: 1.6rem;\n  height: 31px;\n}\n\n.td-truncated {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 200px;\n  cursor: pointer;\n}\n\n.td-expanded {\n  white-space: normal !important;\n  overflow: visible !important;\n  max-width: none !important;\n}\n\n.full-width {\n  width: 100% !important;\n  max-width: 100% !important;\n}\n\n.navbar {\n  align-items: stretch;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n}\n\n.navbar-section {\n  align-items: center;\n  display: flex;\n  /*flex: 1 0 0;*/\n}\n\n.navbar-section:not(:first-child):last-child {\n  justify-content: flex-end;\n}\n\n.navbar-section:first-child > * {\n  margin-right: 0.4rem;\n}\n\n.navbar-section:not(:first-child):last-child > * {\n  margin-left: 0.4rem;\n}\n\n.navbar-section > * {\n  height: 100%;\n}\n\n.titlebar-controls i {\n  font-size: 16px;\n  margin-left: 10px;\n  cursor: pointer;\n}\n\n.label {\n  padding: 0px 4px 1px 4px;\n  border-radius: 0.1rem;\n  vertical-align: top;\n  display: inline-block;\n  background: #f5f5f5;\n  color: #050505;\n}\n\n.category-tag {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.15rem 0.5rem;\n  border-radius: 1rem;\n  font-size: 0.75rem;\n  margin: 0.1rem;\n  background: var(--secondary);\n  color: var(--accent-1);\n}\n\n.category-tag.blended {\n  background: #6C5CE7;  /* soft purple */\n  color: #ffffff;\n}\n\n.category-tag.classroom {\n  background: #0984E3;  /* clear blue */\n  color: #ffffff;\n}\n\n.category-tag.online {\n  background: #00B894;  /* teal green */\n  color: #ffffff;\n}\n\n.category-tag.practical-assessment {\n  background: #E17055;  /* warm orange/red */\n  color: #ffffff;\n}\n\n.category-tag.unassigned {\n  background: #B2BEC3;  /* neutral grey */\n  color: #2d3436;\n}\n\n.category-tag.category-custom {\n  display: inline-block;\n  max-width: 150px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  vertical-align: middle;\n}\n\n.label-circle {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.label-circle-message {\n  display: flex;\n  align-items: flex-start; /* aligns dot to first line */\n  gap: 0.5rem; /* spacing between dot and text */\n}\n\n.label-circle::before {\n  content: \"\";\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: var(--light);\n  flex-shrink: 0;\n}\n\n.label-circle-message::before {\n  content: \"\";\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: var(--light);\n  flex-shrink: 0;\n  margin-top: 6px; /* adjust slightly for perfect alignment */\n}\n\n.bg-success,\n.label.label-success,\n.label-circle.label-success::before {\n  background: var(--passed) !important;\n}\n\n.bg-success,\n.label.label-success,\n.label-circle-message.label-success::before {\n  background: var(--passed) !important;\n}\n\n.bg-warning,\n.label.label-warning,\n.label-circle.label-warning::before {\n  background: var(--warn) !important;\n}\n\n.bg-warning,\n.label.label-warning,\n.label-circle-message.label-warning::before {\n  background: var(--warn) !important;\n}\n\n.bg-error,\n.label.label-error,\n.label-circle.label-error::before {\n  background: var(--failed) !important;\n}\n\n.bg-error,\n.label.label-error,\n.label-circle-message.label-error::before {\n  background: var(--failed) !important;\n}\n\n.bg-info,\n.label.label-info,\n.label-circle.label-info::before {\n  background: var(--info) !important;\n}\n\n.bg-info,\n.label.label-info,\n.label-circle-message.label-info::before {\n  background: var(--info) !important;\n}\n\n.text-larger,\n.text-larger i {\n  font-size: 1.2rem;\n}\n.text-sm,\n.text-sm i {\n  font-size: 1.0rem;\n}\n.text-xs,\n.text-xs i {\n  font-size: 0.875rem;\n}\n\n.col-10 {\n  flex: 10%;\n}\n\n.col-12 {\n  flex: 12%;\n}\n\n.col-15 {\n  flex: 15%;\n}\n\n.col-20 {\n  flex: 20%;\n}\n\n.col-25 {\n  flex: 25%;\n}\n\n.col-30 {\n  flex: 30%;\n}\n\n.col-33 {\n  flex: 33.3333%;\n}\n\n.col-35 {\n  flex: 35%;\n}\n\n.col-40 {\n  flex: 40%;\n}\n\n.col-50 {\n  flex: 50%;\n}\n\n.col-60 {\n  flex: 60%;\n}\n\n.col-66 {\n  flex: 66.6666%;\n}\n\n.col-70 {\n  flex: 70%;\n}\n\n.col-80 {\n  flex: 80%;\n}\n\n.col-85 {\n  flex: 85%;\n}\n\n.col-88 {\n  flex: 88%;\n}\n\n.col-90 {\n  flex: 90%;\n}\n\n.col-100 {\n  flex: 100%;\n}\n\n.mt-0 {\n  margin-top: 0 !important;\n}\n\n.mt-1 {\n  margin-top: 0.4rem !important;\n}\n\n.mt-2 {\n  margin-top: 0.8rem !important;\n}\n\n.mt-5 {\n  margin-top: 3rem !important;\n}\n\n.mb-0 {\n  margin-bottom: 0 !important;\n}\n\n.mb-1 {\n  margin-bottom: 0.4rem !important;\n}\n\n.mb-2 {\n  margin-bottom: 0.8rem !important;\n}\n\n.mb-3 {\n  margin-bottom: 1.2rem !important;\n}\n\n.mr-0 {\n  margin-right: 0 !important;\n}\n\n.mr-1 {\n  margin-right: 0.4rem !important;\n}\n\n.mr-2 {\n  margin-right: 0.8rem !important;\n}\n\n.ml-0 {\n  margin-left: 0 !important;\n}\n\n.ml-1 {\n  margin-left: 0.4rem !important;\n}\n\n.ml-2 {\n  margin-left: 0.8rem !important;\n}\n\n.m-0 {\n  margin: 0 !important;\n}\n\n.m-1 {\n  margin: 0.4rem !important;\n}\n\n.m-2 {\n  margin: 0.8rem !important;\n}\n\n.p-0 {\n  padding: 0 !important;\n}\n\n.p-1 {\n  padding: 0.4rem;\n}\n\n.p-2 {\n  padding: 0.8rem;\n}\n\n.pt-0 {\n  padding-top: 0 !important;\n}\n\n.pt-1 {\n  padding-top: 0.4rem !important;\n}\n\n.pt-2 {\n  padding-top: 0.8rem !important;\n}\n\n.pt-5 {\n  padding-top: 3rem !important;\n}\n\n.pb-0 {\n  padding-bottom: 0 !important;\n}\n\n.pb-1 {\n  padding-bottom: 0.4rem !important;\n}\n\n.pb-2 {\n  padding-bottom: 0.8rem !important;\n}\n\n.pr-0 {\n  padding-right: 0 !important;\n}\n\n.pr-1 {\n  padding-right: 0.4rem !important;\n}\n\n.pr-2 {\n  padding-right: 0.8rem !important;\n}\n\n.pl-0 {\n  padding-left: 0 !important;\n}\n\n.pl-1 {\n  padding-left: 0.4rem !important;\n}\n\n.pl-2 {\n  padding-left: 0.8rem !important;\n}\n\n.padding {\n  padding: 0.4rem;\n  box-sizing: border-box;\n}\n\n.page-content-inner > .padding:not(:first-child) {\n  border-top: 1px solid var(--light);\n  margin-top: 0.4rem;\n  padding-top: 0.8rem;\n}\n\n.text-gray {\n  color: var(--light);\n}\n\n.text-gray i::after {\n  border-left-color: var(--light) !important;\n  border-bottom-color: var(--light) !important;\n}\n\n.text-primary {\n  color: var(--accent-1);\n}\n\n.text-secondary {\n  color: var(--accent-2);\n}\n\n.text-error {\n  color: var(--failed);\n}\n\n.text-warning {\n  color: var(--warn);\n}\n\n.text-info {\n  color: var(--info);\n}\n\n.text-success {\n  color: var(--passed);\n}\n\n.text-center {\n  text-align: center;\n}\n\n.ellipsis {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.full-text {\n  white-space: normal;\n  overflow: visible;\n}\n\n.text-label {\n  color: var(--accent-2);\n  text-transform: uppercase;\n  font-weight: 500;\n  font-size: 0.85rem;\n}\n\n.text-bold {\n  font-weight: 700;\n}\n\n.text-bolder {\n  font-weight: 600;\n}\n\n.text-italic {\n  font-style: italic;\n}\n\n.text-italic-course-description {\n  font-style: italic;\n  display: inline-flex;\n  padding-left: 5px;\n}\n\n.text-uppercase {\n  text-transform: uppercase;\n}\n\n.c-hand {\n  cursor: pointer;\n}\n\n.clickable:hover {\n  background-color: var(--lighter);\n  cursor: pointer;\n  text-decoration: none;\n  border: none;\n}\n\n.center-this {\n  width: 100%;\n  padding: 3rem 0;\n}\n\n.disabled {\n  pointer-events: none;\n  opacity: 0.5;\n}\n\ninput,\nselect,\ntextarea,\n.input {\n  border: 1px solid transparent;\n  background: var(--lighter);\n  color: var(--dark);\n  padding: 0.4rem 0.6rem;\n  border-radius: 0.1rem;\n  box-sizing: border-box;\n  max-width: 100%;\n  min-height: 30px;\n}\n\n.input[contenteditable] {\n  background: none;\n  border: 1px solid var(--dark);\n  border-top: none;\n  outline: none;\n  max-height: 400px;\n  min-height: 150px;\n  overflow: auto;\n}\n\n.text-editor.compact .input[contenteditable] {\n  min-height: 38px;\n  max-height: 100px;\n}\n\nselect[multiple] {\n  min-height: 200px;\n}\n\nlabel input {\n  min-height: unset;\n  padding: unset;\n  border: unset;\n  background: unset;\n}\n\ntextarea {\n  resize: vertical;\n  font-family: inherit;\n}\n\n.has-error input,\ninput.has-error {\n  border: 1px solid var(--failed);\n}\n\ninput[type=\"search\"] {\n  background: none;\n  border: 1px solid var(--accent-2);\n  border-radius: 0.2rem;\n}\n\n.form input[type=\"search\"] {\n  border: 1px solid transparent;\n  background: var(--lighter);\n  border-radius: 0.1rem;\n}\n\n[type=\"search\"]::-webkit-search-cancel-button,\n[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n.autocomplete {\n  position: relative;\n}\n\n.autocomplete ul {\n  position: absolute;\n  width: 100%;\n  max-height: 150px;\n  background: var(--bg);\n  box-sizing: border-box;\n  overflow: auto;\n  z-index: 9;\n}\n\n.autocomplete ul:not(:empty) {\n  border: 1px solid var(--accent-1);\n  display: none;\n}\n\n.autocomplete input:focus ~ ul,\n.autocomplete ul:hover {\n  display: block;\n}\n\n.autocomplete li {\n  cursor: pointer;\n  padding: 0.2rem 0.4rem;\n}\n\n.autocomplete li:hover {\n  background: var(--light);\n}\n\n.form {\n  max-width: 400px;\n}\n\n.form.bordered-sections > .form-section:not(:last-child) {\n  border-bottom: 1px solid var(--lighter);\n  padding-bottom: 1rem;\n}\n\n.centered-page-form {\n  margin: 3% auto;\n  width: 300px;\n}\n\n.form-buttons {\n  margin-top: 0.8rem;\n  display: flex;\n  /*justify-content: flex-end;*/\n}\n\n.form-buttons.flex-right {\n  justify-content: flex-end;\n}\n\n.form-buttons button:not(:first-child) {\n  margin-left: 0.4rem;\n}\n\n.form-buttons a:hover {\n  text-decoration: underline;\n}\n\n.form-buttons a:visited,\n.form-buttons a:active,\n.form-buttons a:focus {\n  color: var(--accent-1);\n}\n\n.form-section {\n  margin-bottom: 1rem;\n}\n\n.form-section.form-section-narrow {\n  max-width: 300px;\n}\n\n.details-list .form-section {\n  margin-bottom: 1.4rem;\n}\n\n.form-section input:not([type=checkbox]):not([type=radio]),\n.form-section select,\n.form-section textarea {\n  width: 100%;\n  max-width: 100%;\n}\n\n.form-section input:focus,\n.form-section select:focus,\n.form-section textarea:focus {\n  border: 1px solid var(--accent-2);\n}\n\n.form-section.with-button {\n  display: flex;\n}\n\n.form-section.with-button > *:first-child {\n  flex: 1;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.form-section.with-button > button {\n  min-width: 30px;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.form-section.has-error .form-label {\n  color: var(--failed) !important;\n}\n\n.form-section-shared {\n  display: flex;\n  justify-content: space-between;\n}\n\n.form-section-shared > .form-section {\n  flex: auto;\n  max-width: 50%;\n}\n\n.form-section-shared > .form-section:first-child {\n  padding-right: 0.8rem;\n  box-sizing: border-box;\n}\n\n.form-section.agenda-input {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.form-section.agenda-input .form-label {\n  width: 100%;\n}\n\n.form-section.agenda-input input:nth-child(2n) {\n  flex: 29%;\n  margin-right: 1%;\n}\n\n.form-section.agenda-input input:nth-child(3n) {\n  flex: 59%;\n  margin-right: 1%;\n}\n\n.form-section.agenda-input button {\n  flex: 9%;\n}\n\n.form-input label {\n  display: block;\n}\n\n.centered-page-form .form-section {\n  margin-bottom: 0.8rem;\n}\n\n.checkbox-section i {\n  font-size: 1.4rem;\n  vertical-align: bottom;\n}\n\n.checkbox-section > div:first-child:not(.loading) {\n  cursor: pointer;\n}\n\n.checkbox-section > div:not(:first-child):last-child {\n  margin-left: 1.8rem;\n}\n\n.form-label {\n  margin-bottom: 0.2rem;\n  font-size: 0.9rem;\n}\n\n.form-label:empty {\n  height: 1.2rem;\n}\n\n.required .form-label::after {\n  content: \"*\";\n  color: var(--failed);\n  padding-left: 0.1rem;\n}\n\n.form img {\n  max-width: 100%;\n}\n\n.signature-editor {\n  width: 100%;\n  background: var(--lighter);\n  border-radius: 2rem;\n\n  .signature-elements {\n    padding: 20px;\n\n    .clear-button {\n      float: right;\n    }\n\n    /* .signature-canvas {\n      width: 100%;\n    } */\n\n    .signature-hint {\n      color: #999;\n      text-align: center;\n    };\n\n    .signature-line {\n      width: 90%;\n    }\n  }\n}\n\n\n/* FORM UNIT & FORM PREVIEW */\n\n.form-unit {\n  width: 100%;\n  max-width: 450px;\n  align-self: flex-start;\n  max-height: 80%;\n  margin: 0 auto;\n  margin-top: 5%;\n  background: var(--bg);\n  border: 1px solid var(--dark);\n  z-index: 1;\n  position: relative;\n  overflow-y: auto;\n  box-sizing: border-box;\n  padding: 2.4rem;\n}\n\n.form-preview .titlebar {\n  display: flex;\n  justify-content: space-between;\n  padding-bottom: 1.4rem;\n  border-bottom: 1px solid var(--lighter);\n  box-sizing: border-box;\n  text-transform: uppercase;\n  font-weight: 500;\n  font-size: 0.85rem;\n  align-items: center;\n}\n.form-preview .titlebar-section {\n  display: flex;\n}\n\n.form-unit.form-preview .form-section {\n  padding: 0.2rem 0;\n}\n\n.form-unit.form-preview .form-section:hover {\n  outline: 2px dotted var(--accent-1);\n  outline-offset: 2px;\n  cursor: pointer;\n  position: relative;\n}\n\n.form-unit.form-preview .form-section *:hover {\n  cursor: pointer;\n}\n\n.radio-button {\n  position: relative;\n  display: inline-block;\n}\n\n.radio-button:before {\n  content: \"\";\n  border: 1px solid var(--dark);\n  border-radius: 50%;\n  display: inline-block;\n  width: 12px;\n  height: 12px;\n  margin-left: 0.3rem;\n  margin-top: 0.15rem;\n  position: relative;\n}\n\n.radio-button.checked:after {\n  content: \"\";\n  background-color: var(--dark);\n  border-radius: 15px;\n  display: block;\n  top: 5px;\n  left: 3px;\n  width: 8px;\n  height: 8px;\n  position: absolute\n}\n\n.field-options .radio-button:before {\n  border: 1px solid var(--dark);\n  width: 10px;\n  height: 10px;\n  margin-left: 1px;\n}\n\n.field-options .radio-button.checked:after {\n  background-color: var(--dark);\n  top: 5px;\n  left: 4px;\n  width: 6px;\n  height: 6px;\n}\n\n.form-preview .radio-button {\n  vertical-align: middle;\n}\n\n.number-icon:before {\n  content: \"123\";\n  font-size: 0.6rem;\n  vertical-align: middle;\n}\n\n/* CERTIFICATE UNIT EDITOR & TEXT EDITOR */\n\n.text-editor-toolbar {\n  display: flex;\n  border: 1px solid var(--accent-1);\n  padding: 0 0.4rem;\n  border-radius: 0.2rem;\n  line-height: 28px;\n  height: 30px;\n  white-space: nowrap;\n}\n\n.text-editor-toolbar i {\n  cursor: pointer;\n  font-size: 20px;\n  height: 100%;\n  padding: 0 0.2rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.text-editor-toolbar i:before {\n  padding-bottom: 1px;\n}\n\n.text-editor-toolbar > *:hover {\n  background: var(--accent-1);\n  color: var(--lighter);\n  border-radius: 0.2rem;\n}\n\n.tab-dropdown {\n  position: relative;\n}\n\n.tab-dropdown ul {\n  position: absolute;\n  top: 22px;\n  left: 0;\n  min-width: 100%;\n  display: none;\n  background-color: var(--lighter);\n  margin: 0;\n  z-index: 99;\n  border: 1px solid var(--accent-2);\n  border-radius: 0 0 0.2rem 0.2rem;\n  overflow: hidden;\n  box-sizing: border-box;\n}\n\n.tab-dropdown-right ul {\n  right: 0;\n  left: unset;\n}\n\n.tab-dropdown:hover ul {\n  display: block;\n  z-index: 50;\n}\n\n.tab-dropdown ul li {\n  list-style: none;\n  margin: 0;\n  padding: 5px 10px;\n  color: var(--dark);\n  line-height: 1.25;\n  white-space: nowrap;\n  cursor: pointer;\n}\n\n.tab-dropdown ul li:hover {\n  background-color: var(--light);\n  outline: 1px solid var(--dark)\n}\n\n/* CERTIFICATE PREVIEW */\n\n.cert-variables code {\n  word-break: break-all;\n}\n\n.certificate-preview {\n  position: relative;\n  flex: none;\n  align-self: flex-start;\n  width: 600px;\n  max-width: 100%;\n  /*margin: 0 auto;*/\n  border: 1px solid var(--light);\n  background: #fff;\n  overflow: hidden;\n  font-size: 24pt;\n  color: #000;\n}\n\n.certificate-preview.landscape {\n  width: 1000px;\n}\n\n.certificate-preview.portrait:before,\n.certificate-preview:before {\n  content: \"\";\n  display: block;\n  padding-top: 141%;\n}\n\n.certificate-preview.landscape:before {\n  content: \"\";\n  display: block;\n  padding-top: 70%;\n}\n\n.certificate-preview img {\n  position: absolute;\n  height: 100%;\n  top: 0;\n  left: 0;\n}\n\n.certificate-preview .text-editor-input span {\n  font-size: inherit;\n  line-height: 1.5;\n}\n\n.cert-editor {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n\n.cert-scaler {\n  position: absolute;\n  transform-origin: top left;\n  width: 210mm;\n  height: 297mm;\n}\n\n.landscape .cert-scaler {\n  width: 297mm;\n  height: 210mm;\n}\n\n.cert-body {\n  height: 80%;\n  top: 10%;\n}\n\n.cert-header,\n.cert-body {\n  border-bottom: 1px dashed #fbfbfb;\n  box-sizing: border-box;\n}\n\n.cert-header,\n.cert-footer {\n  height: 10%;\n}\n\n.cert-header,\n.cert-body,\n.cert-footer {\n  box-sizing: border-box;\n  padding-left: 10px;\n  padding-right: 10px;\n}\n\n.cert-header {\n  padding-top: 10px;\n}\n\n.cert-footer {\n  top: 90%;\n  padding-bottom: 10px;\n}\n\n.cert-editor li {\n  list-style: unset;\n}\n\n/* SMALL CERTIFICATE PREVIEWS */\n\n.centered-layout .certs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 15px 15px;\n  justify-content: space-around;\n}\n\n.cert-icon {\n  cursor: pointer;\n  vertical-align: top;\n}\n\n.cert-icon-info {\n  text-align: center;\n}\n\n.cert-icon-image {\n  position: relative;\n  margin: 0 auto;\n  width: 212px;\n  height: 100px;\n  border-radius: 0.1rem;\n  overflow: hidden;\n  background-color: var(--light);\n  background-size: cover;\n  background-repeat: no-repeat;\n  margin-bottom: 5px;\n  pointer-events: none;\n  border: 1px solid var(--light);\n}\n\n.cert-icon-image.portrait,\n.cert-icon-image.landscape {\n  height: unset;\n}\n\n\n.cert-icon-image.portrait {\n  width: 150px;\n}\n\n.cert-icon-image.portrait:before {\n  content: \"\";\n  display: block;\n  padding-top: 141%;\n}\n\n.cert-icon-image.landscape:before {\n  content: \"\";\n  display: block;\n  padding-top: 70%;\n}\n\n.cert-icon-image iframe {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  width: 100%;\n  height: 100%;\n}\n\n/* ----- */\n\n/* Tooltip */\n.tooltip {\n  position: relative;\n}\n\n.tooltip:hover::after {\n  opacity: 1;\n  transform: translate(-50%, -.2rem);\n}\n\n.tooltip:after {\n  font-family: sans-serif;\n}\n\n.tooltip::after {\n  background: var(--dark);\n  border-radius: .1rem;\n  bottom: -100%;\n  color: var(--lighter);\n  content: attr(data-tooltip);\n  display: block;\n  font-size: .7rem;\n  left: 50%;\n  max-width: 320px;\n  opacity: 0;\n  overflow: hidden;\n  padding: .2rem .4rem;\n  pointer-events: none;\n  position: absolute;\n  text-overflow: ellipsis;\n  transform: translate(-50%, .4rem);\n  transition: opacity .2s, transform .2s;\n  white-space: pre;\n  z-index: 300;\n}\n\n.inline-tip {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 1.5rem;\n  white-space: nowrap;\n}\n\n.inline-tip::after {\n  content: attr(data-tip);\n  color: var(--dark);\n  font-size: 0.75rem;\n  white-space: nowrap;\n}\n\n/* ------- */\n\n.has-icon-left, .has-icon-right {\n  position: relative;\n}\n\n.has-icon-right > *:first-child {\n  padding-right: 1.3rem;\n  height: 100%;\n  vertical-align: top;\n}\n\n.has-icon-right i {\n  right: .05rem;\n  color: var(--dark);\n}\n\n.has-icon-right input:focus ~ i,\n.has-icon-right input:not(:placeholder-shown) ~ i {\n  /*color: var(--lighter);*/\n}\n\n.has-icon-left i, .has-icon-right i {\n  margin-left: 0.25rem;\n  margin-right: 0.4rem;\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: 2;\n}\n\n.has-icon-right i:first-of-type:not(:last-of-type) {\n  display: none;\n  margin-right: 1.8rem;\n}\n\n.has-icon-right input:not(:placeholder-shown) ~ i:first-of-type:not(:last-of-type) {\n  display: block;\n}\n\n.btn,\nbutton {\n  font-family: inherit;\n  border: 1px solid var(--accent-1);\n  padding: 0 0.4rem;\n  background: transparent;\n  cursor: pointer;\n  color: var(--accent-1);\n  transition: 0.1s;\n  border-radius: 0.2rem;\n  font-weight: 500;\n  line-height: 28px;\n  height: 30px;\n  white-space: nowrap;\n}\n\n.btn-padded {\n  padding: 0.8rem 1.6rem;\n  line-height: normal;\n  height: auto;\n}\n\n.btn.with-icon,\nbutton.with-icon {\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  padding-right: 0.6rem;\n}\n\n.dropbtn {\n  background-color: #04AA6D;\n  color: white;\n  padding: 16px;\n  font-size: 16px;\n  border: none;\n  cursor: pointer;\n}\n\n.dropbtn:hover, .dropbtn:focus {\n  background-color: #3e8e41;\n}\n\n#orgs-dropdown-input:focus {outline: 3px solid #ddd;}\n\n.orgs-dropdown {\n  position: relative;\n  display: inline-block;\n}\n\n.dropdown-content {\n  display: none;\n  position: absolute;\n  background-color: #f6f6f6;\n  min-width: 230px;\n  overflow: auto;\n  border: 1px solid #ddd;\n  z-index: 1;\n}\n\n.dropdown-content a {\n  color: black;\n  padding: 12px 16px;\n  text-decoration: none;\n  display: block;\n}\n\ndiv#orgs-dropdown-items {\n  max-height: 60vh;\n}\n\n.dropdown a:hover {background-color: #ddd;}\n\n.show {display: block;}\n\n.inc-acct-users {\n  margin-bottom: 0px;\n}\n\n.with-icon.icon-right {\n  padding-right: 0.4rem;\n  padding-left: 0.6rem;\n}\n\n.with-icon i {\n  padding-right: 0.2rem;\n}\n\n.with-icon.icon-right i {\n  padding-right: 0;\n  padding-left: 0.2rem;\n}\n\n.no-click {\n  pointer-events: none;\n}\n\n.disable-buttons button,\n.disable-buttons .btn,\nbuttons.disabled {\n  opacity: 0.5;\n  pointer-events: none;\n}\n\n.disable-fields input,\n.disable-fields textarea,\n.disable-fields select,\n.disable-fields label,\n.disable-fields button,\n.disable-fields .signature-editor,\ninput.disable-fields,\ntextarea.disable-fields,\nselect.disable-fields,\nlabel.disable-fields,\n.signature-editor.disable-fields {\n  pointer-events: none;\n}\n\n.btn-secondary {\n  background-color: var(--light);\n  border-color: var(--light);\n}\n\n.btn-text {\n  border: none;\n  background: none;\n}\n\n.btn-inverted {\n  border: 2px solid var(--lighter);\n  background: var(--lighter);\n  color: var(--accent-1);\n}\n\n.btn-cta {\n  background: var(--accent-1);\n  color: var(--lighter);\n}\n\n\n.btn-cta:hover {\n  background: var(--accent-2);\n}\n\n.btn-focus {\n  background: var(--accent-1);\n  color: var(--lighter);\n}\n\n.btn-focus:hover {\n  outline: 2px solid var(--accent-1);\n}\n\n.btn-open::after {\n  font-family: 'spudfont' !important;\n  content: \"\\e96a\";\n  font-size: 0.85rem;\n  margin-left: 0.4rem;\n}\n\n.datepicker-container {\n  position: relative;\n  display: inline-block;\n}\n\n.datepicker-input {\n  padding-right: 30px; /* Make space for the icon */\n}\n\n.calendar-icon {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  pointer-events: none;\n  color: #333; /* Adjust color as needed */\n}\n\n.btn-error {\n  color: var(--failed);\n  border: 1px solid var(--failed);\n}\n\n.text-danger {\n    color: var(--failed);\n}\n\n.btn-warning {\n  color: var(--warn);\n  border: 1px solid var(--warn);\n}\n\n.btn-info {\n  color: var(--info);\n  border: 1px solid var(--info);\n}\n\n.btn-yes,\n.btn-yes:hover {\n  background: var(--passed);\n  border: 1px solid var(--passed);\n  color: var(--lighter);\n}\n\n.btn-no,\n.btn-no:hover {\n  background: var(--failed);\n  border: 1px solid var(--failed);\n  color: var(--lighter);\n}\n\n.text-italic{\n  font-style: italic;\n}\n\n.username-approver{\n  display: inline;\n  font-weight: normal;\n}\n\n.btn-warning:hover {\n  color: var(--lighter);\n  background: var(--warn);\n}\n\n.btn-cta.btn-warning,\n.btn-cta.btn-warning:hover {\n  background: var(--warn);\n  border: 1px solid var(--warn);\n  color: var(--lighter);\n}\n\n.btn-info:hover {\n  color: var(--lighter);\n  background: var(--info);\n}\n\n.btn-cta.btn-info,\n.btn-cta.btn-info:hover {\n  background: var(--info);\n  border: 1px solid var(--info);\n  color: var(--lighter);\n}\n\n.btn-error:hover {\n  color: var(--lighter);\n  background: var(--failed);\n}\n\n.btn-cta.btn-error,\n.btn-cta.btn-error:hover {\n  background: var(--failed);\n  border: 1px solid var(--failed);\n  color: var(--lighter);\n}\n\n/* --- ALERTS --- */\n\n.alert {\n  gap: 0.5rem;\n  padding: 0.75rem 1rem;\n  border-radius: 4px;\n  border: 1px solid;\n  font-size: 0.9rem;\n  line-height: 1.5;\n}\n.alert-flex {\n  display: flex;\n  align-items: flex-start;\n}\n\n.alert-success {\n  color: #035e30;\n  background: #e6fcf1;\n  border-color: var(--passed);\n}\n\n.alert-error {\n  color: #8b1c1c;\n  background: #fcebea;\n  border-color: var(--error);\n}\n\n.alert-warning {\n  color: #7a4500;\n  background: #fff6eb;\n  border-color: var(--warn);\n}\n\n.alert-info {\n  color: #01527e;\n  background: #e6f3fa;\n  border-color: var(--info);\n}\n\n.btn-padding button,\n.btn-padding .btn,\nbutton.btn-padding,\n.btn.btn-padding {\n  padding: 0 0.8rem;\n}\n\n.btn-pulse {\n  animation: pulse-animation 2s infinite;\n}\n\n@keyframes pulse-animation {\n  0% {\n    box-shadow: 0 0 0 0 rgba(207, 76, 77, 0.7);\n  }\n\n  100% {\n    box-shadow: 0 0 0 7px rgba(207, 76, 77, 0);\n  }\n}\n\n.btn-big {\n  width: 30%;\n  height: 75px;\n  display: inline-flex !important;\n  margin: 0.4rem;\n  justify-content: center !important;\n  font-weight: 600;\n}\n\n.btn-small {\n  font-size: 0.8rem;\n  height: 20px;\n  line-height: 20px;\n}\n\n.toggle-section {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.btn.btn-toggle {\n  height: 1.2rem;\n  width: 2.4rem;\n  min-width: 2.4rem;\n  padding: 0;\n  display: inline-flex;\n  vertical-align: text-top;\n  align-items: center;\n  line-height: 1;\n  background: var(--accent-1);\n  opacity: 0.3;\n  transition: 0.1s;\n}\n\n.btn.btn-toggle.active {\n  opacity: 1;\n  flex-direction: row-reverse;\n}\n\n.btn.btn-toggle::after {\n  display: block;\n  width: 0.9rem;\n  min-width: 0.9rem;\n  height: 0.9rem;\n  background: var(--lighter);\n  margin: 0.2rem;\n  border-radius: 0.1rem;\n  content: '';\n  font-family: 'spudfont' !important;\n  speak: none;\n  font-style: normal;\n  font-variant: normal;\n  text-transform: none;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  font-size: 0.9rem;\n  color: var(--dark);\n  font-weight: 600;\n}\n\n.btn.btn-toggle.active::after {\n  content: '\\e92f';\n}\n\n.btn.btn-toggle[disabled],\n.btn.btn-toggle.disabled {\n  opacity: 0.15;              /* override active opacity */\n  cursor: not-allowed;\n  pointer-events: none;\n  filter: grayscale(100%);\n}\n\na:focus,\nbutton:focus,\ninput:focus,\nselect:focus,\ntextarea:focus,\ncontenteditable:focus {\n  outline: none;\n}\n\n.brackets {\n  background-image: linear-gradient(var(--accent-1), var(--accent-1)), linear-gradient(var(--accent-1), var(--accent-1)), linear-gradient(var(--accent-1), var(--accent-1)), linear-gradient(var(--accent-1), var(--accent-1));\n  background-repeat: no-repeat;\n  background-size: 4px 1px;\n  background-position: top left, top right, bottom left, bottom right;\n  border: solid var(--accent-1);\n  border-width: 0 1px;\n  padding: 0 0.4rem;\n}\n\n.page-content-box + .toolbar {\n  padding-top: 0;\n}\n\nheader.toolbar {\n  padding: 0 0.4rem;\n  height: 40px;\n  line-height: 38px;\n  margin: 0;\n  /*background: var(--lighter);*/\n}\n\nfooter .toolbar {\n  height: 30px;\n  line-height: 28px;\n  background: var(--dark);\n  color: var(--light);\n  border: none;\n}\n\n.main-toolbar {\n  background: var(--accent-1);\n  color: var(--light);\n}\n\n.secondary-toolbar {\n  background: var(--light);\n}\n\n.toolbar-section {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.toolbar-section input,\n.toolbar-section button {\n  height: 30px;\n}\n\n.toolbar-section > *:not(:last-child) {\n  margin-right: 0.4rem;\n}\n\n.toolbar-section.with-menu {\n  align-items: start;\n  flex-direction: column;\n}\n\n.toolbar-section.with-menu .toolbar-section {\n  flex-direction: column;\n  align-items: normal;\n}\n\n.toolbar-section.with-menu .toolbar-menu {\n  margin-top: 1.2rem;\n}\n\n.toolbar-section.with-menu .toolbar-menu > * {\n  margin-right: 1.2rem;\n  font-weight: 500;\n  display: inline-block;\n  cursor: pointer;\n  border-bottom: 2px solid transparent;\n  padding-bottom: 0.4rem;\n  font-size: 1rem;\n}\n\n.toolbar-section.with-menu .toolbar-menu > *.active {\n  border-bottom: 2px solid var(--dark);\n}\n\n.toolbar-section.with-menu .toolbar-menu > *:not(.active):hover {\n  border-bottom: 2px solid var(--dark);\n}\n\n.toolbar-title {\n  padding: 0 0.4rem;\n  white-space: nowrap;\n  height: 100%;\n}\n\n.toolbar-tabs {\n  display: flex;\n  flex-direction: row;\n}\n\n.toolbar-tabs > * {\n  padding: 0 0.4rem;\n  border: none;\n  border-bottom: 1px solid transparent;\n  color: inherit;\n  white-space: nowrap;\n}\n\n.toolbar-tabs > *.active {\n  border-bottom: 2px solid var(--accent-1);\n}\n\n.toolbar-tabs > button:not(.active):hover,\n.toolbar-tabs > a:not(.active):hover {\n  border-bottom: 1px solid var(--accent-2);\n  cursor: pointer;\n}\n\n.toolbar-checkbox {\n  width: 18px;\n  padding: 0 0.4rem;\n  align-self: center;\n  cursor: pointer;\n}\n\n.toolbar-checkbox i,\n.list-checkbox i {\n  font-size: 1.2rem;\n  opacity: 0.3;\n  vertical-align: bottom;\n}\n\n.toolbar-checkbox i.icon-checkbox-checked,\n.list-checkbox i.icon-checkbox-checked {\n  opacity: 1;\n}\n\n.dropdown {\n  position: relative;\n  cursor: pointer;\n  width: fit-content;\n}\n\n.dropdown button {\n  max-width: 100%;\n}\n\n.dropdown:not(.auto-width) button {\n  min-width: 150px;\n}\n\n.dropdown-list {\n  display: none;\n}\n\n.dropdown-no-hover .dropdown-list{\n  display: none !important;\n}\n\n.show-lang-dropdown .dropdown-list {\n  display: block !important;\n  position: absolute;\n  box-sizing: border-box;\n  margin-top: -1px;\n  left: 0;\n  z-index: 9;\n  background: var(--lighter);\n  border: 1px solid var(--accent-1);\n  width: 100%;\n}\n\n.show-lang-dropdown.dropup .dropdown-list {\n  bottom: 100%;\n  margin-bottom: -1px;\n  top: unset;\n}\n\n.show-lang-dropdown .dropdown-list > div {\n  padding: 0.2rem 0.8rem;\n}\n\n.show-lang-dropdown.centered-content .dropdown-list > div {\n  padding: 0.2rem 0;\n  text-align: center;\n}\n\n.show-lang-dropdown .dropdown-list > .active {\n  font-weight: 600;\n}\n\n.show-lang-dropdown .dropdown-list > div:hover {\n  background: var(--light);\n}\n\n.lang-selector {\n  max-height: 60vh;\n  overflow: auto;\n}\n\n.dropdown:hover .dropdown-list,\n.dropdown.open .dropdown-list {\n  display: block;\n  position: absolute;\n  box-sizing: border-box;\n  margin-top: -1px;\n  left: 0;\n  z-index: 9;\n  background: var(--lighter);\n  border: 1px solid var(--accent-1);\n  width: 100%;\n}\n\n.dropdown.dropup .dropdown-list {\n  bottom: 100%;\n  margin-bottom: -1px;\n  top: unset;\n}\n\n.dropdown:hover .dropdown-list > div,\n.dropdown.open .dropdown-list > div {\n  padding: 0.2rem 0.8rem;\n}\n\n.dropdown.centered-content:hover .dropdown-list > div,\n.dropdown.centered-content.open .dropdown-list > div {\n  padding: 0.2rem 0;\n  text-align: center;\n}\n\n.dropdown:hover .dropdown-list > .active,\n.dropdown.open .dropdown-list > .active {\n  font-weight: 600;\n}\n\n.dropdown:hover .dropdown-list > div:hover,\n.dropdown.open .dropdown-list > div:hover {\n  background: var(--light);\n}\n\n#log {\n  height: 0;\n  max-height: 150px;\n  background: var(--dark);\n  overflow-y: auto;\n  color: var(--light);\n  display: flex;\n  flex-direction: column-reverse;\n  transition: 0.2s;\n  padding: 0 0.8rem;\n}\n\n#log.open {\n  height: auto;\n  padding: 0.8rem;\n}\n\n.console-entry {\n  display: flex;\n  align-items: center;\n}\n\n.console-entry .label {\n  margin-right: 0.4rem;\n  line-height: normal;\n}\n\n.console-entry > *:not(.label) {\n  height: 100%;\n}\n\n.big-number-list > * {\n  display: flex;\n}\n\n/*.big-number-list > *:not(:first-child) {\n        border-top: 1px solid var(--light);\n    }*/\n\n.big-number-list.sortable .big-number {\n  cursor: ns-resize;\n}\n\n.big-number {\n  padding: 0.8rem;\n  font-size: 3rem;\n  line-height: 2.6rem;\n  margin-right: 0.8rem;\n  color: var(--light);\n  text-align: center;\n}\n\n.big-number i {\n  display: block;\n  font-size: 1.2rem;\n  margin-top: 0.4rem;\n}\n\n.big-number-list:not(.no-hover) > *:hover .big-number,\n.big-number.active {\n  color: var(--accent-1);\n  transition: 0.2s;\n}\n\n.big-number.passed {\n  color: var(--passed);\n}\n\n.big-number.failed {\n  color: var(--failed);\n}\n\n.big-number.info {\n  color: var(--info);\n}\n\n\n.folder-structure {\n}\n\n.folder-structure .folder {\n  margin-bottom: 0.4rem;\n  cursor: pointer;\n}\n\n.folder-structure .folder:hover {\n  color: var(--accent-2);\n}\n\n.folder-structure .folder.selected {\n  color: var(--accent-1);\n}\n\n.folder-structure .folder.selected > i.icon-folder::before {\n  content: \"\\e95e\";\n}\n\n.folder-structure .folder .folder {\n  margin-left: 2rem;\n}\n\n.folder-structure .folder.no-expand i.icon-forward {\n  visibility: hidden;\n}\n\n.folder-structure .folder.selected i.icon-forward {\n  transform: rotate(90deg);\n  display: inline-block;\n  transition: 0.2s;\n}\n\n.scorm-preview,\n.scorm-preview iframe,\n.document-preview,\n.document-preview iframe {\n  width: 100%;\n  height: 100%;\n}\n\n\n/* Modal */\n.modal {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 1000;\n}\n\n.modal .navbar {\n  margin-bottom: 0.8rem;\n}\n\n.modal .titlebar .navbar-section:first-child {\n  font-size: 1rem;\n}\n\n#modal-bg {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: var(--bg);\n  opacity: 0.8;\n}\n\n#modal-inner {\n  max-width: 400px;\n  max-height: 80%;\n  margin: 0 auto;\n  margin-top: 5%;\n  background: var(--bg);\n  border: 1px solid var(--dark);\n  z-index: 1;\n  position: relative;\n  overflow-y: auto;\n  border-radius: 0.2rem;\n  padding: 2.4rem;\n}\n\n.modal-mid #modal-inner {\n  min-width: 30%;\n}\n\n.modal-large #modal-inner {\n  min-width: 40%;\n}\n\n.modal-wide #modal-inner {\n  min-width: 60%;\n}\n\n.modal-big #modal-inner {\n  min-width: 75%;\n  min-height: 75%;\n  display: flex;\n  flex-direction: column;\n}\n\n.modal-huge #modal-inner {\n  min-width: 90%;\n  min-height: 85%;\n  margin-top: 2%;\n  display: flex;\n  flex-direction: column;\n}\n\n.modal-big #modal-target,\n.modal-huge #modal-target {\n  display: flex;\n  flex-direction: column;\n  flex: auto;\n}\n\n.modal-fill-height #modal-target {\n  flex-direction: row;\n}\n\n.modal .titlebar {\n  display: flex;\n  justify-content: space-between;\n  padding-bottom: 1.4rem;\n  border-bottom: 1px solid var(--lighter);\n  box-sizing: border-box;\n  text-transform: uppercase;\n  font-weight: 500;\n  font-size: 0.85rem;\n  align-items: center;\n}\n\n.modal .titlebar-section {\n  display: flex;\n}\n\n#modal-target,\n.modal-target {\n  padding-top: 1.4rem;\n}\n\n/* Toasts */\n\n#toaster {\n  display: flex;\n  flex-direction: column;\n  position: fixed;\n  z-index: 500;\n  bottom: 1rem;\n  right: 1.8rem;\n  min-width: 20vw;\n  align-items: flex-end;\n}\n\n#toaster > .toast {\n  margin-bottom: 10px;\n  padding: 0.8rem;\n  /*max-width: 50%;*/\n  display: flex;\n  justify-content: space-between;\n  border-radius: 0.2rem;\n  box-shadow: 0 3px 3px 0 rgba(0,0,0,0.2);\n}\n\n#toaster > .toast > button {\n  float: right;\n  border: none;\n  padding: 0;\n}\n\n#toaster > .toast > button:hover {\n  background: unset;\n}\n\n#toaster > .toast.toast-success {\n  background: var(--passed);\n  color: #fff;\n}\n\n#toaster > .toast.toast-error {\n  background: var(--failed);\n  color: #fff;\n}\n\n#toaster > .toast.toast-info {\n  background: var(--info);\n  color: #fff;\n}\n\n#toaster > .toast.toast-warn {\n  background: var(--warn);\n  color: #111;\n}\n\n#toaster > .toast i {\n  /*color: var(--light);*/\n  font-weight: bold;\n  display: flex;\n  /*align-items: center;*/\n}\n\n#toaster > .toast:not(.toast-ghost) {\n  animation: toast-fadein 0.75s;\n}\n\n#toaster > .toast h6 {\n  margin-bottom: 0;\n}\n\n.toast-ghost {\n  opacity: 0.5;\n}\n\n@keyframes toast-fadein {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n/* Loading */\n\n.loading-bar {\n  height: 5px;\n  border: 1px solid var(--accent-1);\n  position: relative;\n}\n\n.loading-width {\n  background: var(--accent-1);\n  height: 100%;\n  width: 0;\n}\n\n.loading-dots {\n  display: inline-block;\n}\n\n.loading-dots:after {\n  color: var(--light);\n  display: inline-block;\n  content: \"\";\n  animation-name: loading-dots-keyframes;\n  animation-duration: 2s;\n  animation-iteration-count: infinite;\n  animation-timing-function: linear;\n}\n\n@keyframes loading-dots-keyframes {\n  0% {\n    content: \"\\a0\\a0\\a0\"\n  }\n\n  33% {\n    content: \".\\a0\\a0\"\n  }\n\n  66% {\n    content: \"..\\a0\"\n  }\n\n  99% {\n    content: \"...\"\n  }\n}\n\n/*.loading {\n    pointer-events: none;\n}\n\n    .loading > i {\n        color: transparent !important;\n        min-height: .8rem;\n        pointer-events: none;\n        position: relative;\n    }\n\n        .loading > i::before {\n            display: none;\n        }\n\n        .loading > i::after {\n            animation: loading .5s infinite linear;\n            background: 0 0;\n            border: 1px solid var(--dark);\n            border-radius: 50%;\n            border-right-color: transparent;\n            border-top-color: transparent;\n            content: \"\";\n            display: inline-block;\n            height: 0.8rem;\n            opacity: 1;\n            padding: 0;\n            width: 0.8rem;\n            z-index: 1;\n            margin: 0 0.2rem;\n        }\n\n    .loading.loading-big i::after {\n        height: 3rem;\n        width: 3rem;\n    }\n\n@keyframes loading {\n    0% {\n        transform: rotate(0)\n    }\n\n    100% {\n        transform: rotate(360deg)\n    }\n}*/\n\n/* Loading 2 */\n\n.loading {\n  display: block;\n  position: absolute;\n  top: 20%;\n  left: 50%;\n  height: 50px;\n  width: 50px;\n  margin: -25px 0 0 -25px;\n}\n\n.loading span {\n  position: absolute;\n  display: block;\n  bottom: 10px;\n  width: 9px;\n  height: 15px;\n  background: var(--accent-1);\n  opacity: 0.25;\n  -webkit-animation: loading 2s infinite ease-in;\n  animation: loading 2s infinite ease-in;\n}\n\n.loading.loading-invert span {\n  background: var(--text) !important;\n}\n\n.loading span:nth-child(2) {\n  left: 11px;\n  -webkit-animation-delay: 0.2s;\n  animation-delay: 0.2s;\n}\n\n.loading span:nth-child(3) {\n  left: 22px;\n  -webkit-animation-delay: 0.4s;\n  animation-delay: 0.4s;\n}\n\n.loading span:nth-child(4) {\n  left: 33px;\n  -webkit-animation-delay: 0.6s;\n  animation-delay: 0.6s;\n}\n\n.loading span:nth-child(5) {\n  left: 44px;\n  -webkit-animation-delay: 0.8s;\n  animation-delay: 0.8s;\n}\n\n.loading.loading-inline {\n  position: static;\n  height: 50px;\n  width: unset;\n  margin: auto;\n  text-align: center;\n}\n\n.loading.loading-inline span {\n  position: static;\n  display: inline-block;\n  margin-right: 2px;\n}\n\n@keyframes loading {\n  0% {\n    background: var(--accent-1);\n    opacity: 0.25;\n  }\n\n  25% {\n    background: var(--accent-1);\n    opacity: 1;\n  }\n\n  50% {\n    background: var(--accent-1);\n    opacity: 0.25;\n  }\n\n  100% {\n    background: var(--accent-1);\n    opacity: 0.25;\n  }\n}\n\n@-webkit-keyframes loading {\n  0% {\n    background: var(--accent-1);\n    opacity: 0.25;\n  }\n\n  25% {\n    background: var(--accent-1);\n    opacity: 1;\n  }\n\n  50% {\n    background: var(--accent-1);\n    opacity: 0.25;\n  }\n\n  100% {\n    background: var(--accent-1);\n    opacity: 0.25;\n  }\n}\n\n.loading.input-loading {\n  position: absolute;\n  top: 8px;\n  left: unset;\n  right: 12px;\n}\n\n/* --- */\n\n.colour-picker {\n}\n\n.colour-picker .text-toggle,\n.colour-picker .pick-colour {\n  background: var(--light);\n  padding: 0 0.5rem;\n  display: flex;\n  align-items: center;\n  border-radius: 0.1rem 0 0 0.1rem;\n  cursor: pointer;\n}\n\n.colour-picker .pick-colour {\n  border-radius: 0 0.1rem 0.1rem 0;\n}\n\n.colour-picker .text-toggle:hover,\n.colour-picker .pick-colour:hover {\n  background: var(--light);\n}\n\n.colour-picker .swatches {\n  text-align: right;\n  border-top: none;\n  padding-top: 0.2rem;\n}\n\n.colour-picker .swatches span {\n  cursor: pointer;\n  border-radius: 0.1rem;\n  display: inline-block;\n  width: 1.6rem;\n  height: 1.6rem;\n  margin: 0.2rem;\n}\n\n\n/* style.css*/\n\n.org-box-list {\n  display: flex;\n  flex-wrap: wrap;\n  padding: 1.6rem;\n  align-content: flex-start;\n  overflow-y: auto;\n}\n\n.org-box-list > div {\n  width: 250px;\n  padding: 0.8rem;\n  box-sizing: border-box;\n}\n\n.org-box-list > div > div {\n  border-radius: 0.1rem;\n  min-height: 250px;\n  overflow: hidden;\n  border: 1px solid var(--light);\n}\n\n.org-box-list > div > div .padding {\n  padding: 0.8rem;\n}\n\n.org-box-list .img {\n  width: 100%;\n  height: 165px;\n  background: var(--lighter);\n  display: flex;\n  align-items: center;\n}\n\n.org-box-list .img img {\n  max-height: 80%;\n  max-width: 80%;\n  margin: 0 auto;\n}\n\n.centre-content {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  width: 100%;\n}\n\n.hyperlink {\n  color: var(--hyperlink-blue) !important;\n}\n\n.hyperlink:hover {\n  text-decoration: underline;\n}\n\n.hyperlink-original {\n  text-decoration: underline;\n  color: var(--hyperlink-blue) !important;\n}\n\n.small-font {\n  font-size: small !important;\n}\n\n/* Chrome, Safari, Edge, Opera */\n.phoneNo > input::-webkit-outer-spin-button,\n input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\n.mobileNo > input[type=number] {\n  -moz-appearance: textfield;\n}\n\n.phoneNumber  {\n  pattern: 0-9;\n}\n\n.courseDescription a {\n  color: #0052CC; /* Custom color for hyperlinks */\n}\n\n.courseDescription a:hover {\n  color: #0052CC; /* Color on hover */\n  text-decoration: underline;\n}\n\n.text-editor .input.richtext i,\n.courseDescription i,\n.instructions i, .richtext i {\n  font-style: italic !important;\n  font-family: inherit !important;\n  font-size: inherit !important;\n}\n\n.instructions b, .richtext b {\n  font-weight: bolder !important;\n}\n\na.hyperlink.disabled {\n    pointer-events: none;\n    color: gray;\n    text-decoration: none;\n    cursor: default;\n    opacity: 0.6;\n}\n\n/* Container section for form rows */\n\n/* Flex row utilities */\n.flex-row {\n    display: flex;\n    flex-direction: row;\n}\n\n.items-center {\n    display: flex;\n    align-items: center;\n}\n\n.justify-between {\n    display: flex;\n    justify-content: space-between;\n}\n\n/* Left-side labels */\n.text-bolder {\n    font-weight: 600; /* bold text */\n    margin-bottom: 0.25rem;\n}\n\n/* Gray/disabled text */\n.text-gray {\n    color: #a0a0a0;\n}\n\n\n.input-small {\n    width: 40px;\n    padding: 0.25rem 0.5rem;\n    font-size: 0.875rem;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n}\n.right-side {\n    display: flex;\n    flex-direction: column;  /* stack vertically */\n    justify-content: space-between; /* toggle top, input bottom */\n    align-items: flex-end; /* align to the right */\n\n}\n\n.input-small {\n    width: 60px !important;\n    padding: 0.25rem 0.5rem;\n    font-size: 0.875rem;\n}\n\n.input-small:disabled {\n    color: #a0a0a0;  /* or text-gray from your Tailwind/variable */\n    background-color: #f5f5f5; /* optional, to indicate disabled visually */\n    cursor: not-allowed;       /* optional, shows the disabled cursor */\n}\n\n.btn-info {\n  color: var(--avetta-blue);\n  border: 1px solid var(--avetta-blue);\n}\n\n.btn-info:hover {\n  color: var(--lighter);\n  background: var(--avetta-blue);\n}\n\n.btn-cta.btn-info,\n.btn-cta.btn-info:hover {\n  background: var(--avetta-blue);\n  border: 1px solid var(--avetta-blue);\n  color: var(--lighter);\n}\n\n.btn.btn-md {\n  min-width: 150px !important;\n}\n.btn.btn-lg {\n  min-width: 200px !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
